import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";

export const CzechResourcesDictionary: ResourceDictionary = {
	Common: {
		AppName: "Modelační studio",
		Years: "{{count}} let",
		Years_one: "{{count}} rok",
		Years_two: "{{count}} roky",
		Years_few: "{{count}} roky",
		Years_other: "{{count}} let",
		YearsLabel: "let",
		YearsLabel_one: "rok",
		YearsLabel_few: "roky",
		YearsLabel_other: "let",
		Month: "měsíc",
		Months: "{{count}} měsíců",
		Months_one: "{{count}} měsíc",
		Months_two: "{{count}} měsíce",
		Months_few: "{{count}} měsíce",
		Months_other: "{{count}} měsíců",
		Continue: "Pokračovat",
		Step: "KROK {{actual}} Z {{count}}",
		TextCopied: "Text byl zkopírován do schránky.",
		Yes: "Ano",
		No: "Ne",
		Choose: "Vyberte",
		Download: "Stáhnout",
		Downloading: "Stahování",
		UnsupportedFileType: "Nepodporovaný typ souboru",
		Email: "E-mail",
		Password: "Heslo",
		ExampleLogin: "např. antonin.vomacka@email.cz",
		PiecesShort: "{{count, number}} ks",
		PiecesSuffix: "ks",
		Units: {
			Czk: "Kč",
			Years: "let",
			Percent: "%",
			Months: "měsíců",
		},
		AtAge: "ve věku {{age}}",
		Active: "Aktivní",
		Inactive: "Neaktivní",
		Actual: "Aktuální",
		Blocked: "Blokováno",
		Canceled: "Zrušeno",
		Cancel: "Zrušit",
		Close: "Zavřít",
		Confirm: "Potvrdit",
		Ended: "Ukončeno",
		All: "Vše",
		AllStatuses: "Všechny stavy",
		PrivacyPolicyLink: "Zásadách zpracování osobních údajů.",
		Error:
			"Něco se pokazilo. Omlouváme se za komplikace. Zkuste to prosím znovu za chvíli.",
		Save_Uppercase: "ULOŽIT",
		Save: "Uložit",
		Reset: "RESET",
		Retry: "Zkusit znovu",
		WithTax: "s DPH",
		WithoutTax: "bez DPH",
		Edit: "Upravit",
		Back: "Zpět",
		Delete: "Smazat",
		PreviousStep: "Předchozí krok",
		SaveAndClose: "Uložit a zavřít",
		SaveSuccess: "Uložení proběhlo úspěšně.",
		CompanyNumber: "IČ",
		TaxNumber: "DIČ",
		PersonalNumber: "RČ",
		ProcessedByRepresentative: "Zpracoval{{gender}} {{name}}",
		SendByRepresentative: "Odeslal{{gender}} {{name}}",
		SignOut: "Odhlásit se",
		Loading: "Načítám…",
		StepperDecrement: "Snížit",
		StepperIncrement: "Zvýšit",
		Apply: "Použít",
	},
	Errors: {
		ApplicationError: {
			Title: "Chyba",
			Heading: "Je nám líto, v aplikaci došlo k chybě.",
			Description:
				"Naši programátoři již o chybě byli informováni a na opravě pracují.",
			DevHint: "Jste programátor? Koukněte v čem byla chyba.",
			Home: "Domů",
		},
		Error404: {
			Title: "Chyba 404",
			Subtitle: "Stránka nebyla nalezena",
			Home: "Domů",
		},
		Error403: {
			Title: "Chyba 403",
			Subtitle: "K zobrazení této stránky nemáte přístupová práva",
		},
		Error500: "Při zpracování požadavku nastala chyba.",
		Server: {
			Network: "Bez připojení k serveru. Zkontrolujte připojení k internetu.",
			BadRequest: "Neplatný požadavek.",
			Unauthorized: "Pro provedení akce se musíte přihlásit.",
			Forbidden: "K této akci nemáte oprávnění.",
			NotFound: "Požadovaný záznam nebyl nalezen.",
			Conflict: "Požadovanou akci nelze v tomto stavu provést.",
			TooManyRequests: "Příliš mnoho požadavků. Zkuste to prosím za chvíli.",
			InternalError: "Při zpracování požadavku nastala chyba na serveru.",
			ExternalUnavailable:
				"Externí služba není dostupná. Zkuste to prosím za chvíli.",
			Unknown: "Něco se nepovedlo. Zkuste to prosím znovu.",
		},
		Reasons: {
			InvalidCredentials: "Neplatné přihlašovací údaje.",
			AccountWaitingForEmailConfirmation: "Účet čeká na potvrzení e-mailu.",
			MissingFileForPdfKind: "Pro PDF modul je nutné nahrát soubor.",
			MissingDefinitionForFormKind: "Formulář nemá uloženou strukturu polí.",
			InvalidDefinition: "Struktura formuláře je neplatná.",
			FormHasNoFields:
				"Formulář musí obsahovat alespoň jedno pole. Přetáhněte prvek z levého panelu.",
			FileMustBeNullForFormKind: "Formulář nesmí obsahovat nahraný soubor.",
			DefinitionMustBeNullForPdfKind:
				"PDF modul nesmí obsahovat strukturu formuláře.",
			MissingAgentIdentification:
				"Broker není připojen k SabApi (chybí registrační číslo).",
			EmptyToken: "Chybí přihlašovací token z externího systému.",
			EmptyMyDockUrl: "Není nastavená adresa myDocku pro tohoto tenanta.",
			Unreachable: "Externí služba není dostupná. Zkuste to prosím za chvíli.",
			Timeout: "Požadavek na externí službu vypršel. Zkuste to prosím znovu.",
			Unauthorized: "Přístup k externí službě byl odmítnut.",
			BadStatus: "Externí služba vrátila neočekávanou odpověď.",
			InvalidResponse: "Odpověď z externí služby se nepodařilo zpracovat.",
			NotShared:
				"Modelace zatím není sdílená. Nejprve vytvořte odkaz pro klienta.",
			ClientEmailMissing:
				"Klient nemá uloženou e-mailovou adresu, e-mail nelze odeslat.",
		},
	},
	SignIn: {
		Error: {
			General: "Přihlášení se nezdařilo.",
			InvalidCredentials: "Neplatné přihlašovací údaje",
			AccountWaitingForEmailConfirmation: "Účet čeká na potvrzení e-mailu.",
		},
		Title: "Přihlášení",
		Login: {
			Label: "Přihlášení",
		},
		Password: {
			Label: "Heslo",
		},
		Button: "Přihlásit",
	},
	BrokerAuth: {
		Title: "Přesměrování",
		InProgress: "Probíhá přihlášení…",
		Error: {
			General: "Přihlášení přes externí systém se nezdařilo.",
			MissingToken: "Chybí přihlašovací token.",
		},
	},
	SignUp: {
		Error: {
			General: "Nastala chyba",
			UserExists: "Účet již existuje",
			WeakPassword:
				"Heslo musí mít alespoň 8 znaků, obsahovat jedno malé, jedno velké písmeno a jedno číslo",
		},
	},
	SetPassword: {
		Error: {
			General: "Nastala chyba",
			TokenNotFound: "Token nebyl nalezen",
			WeakPassword: "Heslo je příliš slabé",
		},
	},
	Validation: {
		Required: "Vyplňte pole",
		InvalidEmail: "E-mail je nevalidní",
		AlphabetsOnly: "Pro toto pole jsou povoleny pouze písmenka",
		DigitsOnly: "Může obsahovat pouze číslice",
		InvalidPhone: "Telefonní číslo je nevalidní",
		InvalidFormat: "Neplatný formát",
		InvalidBankAccount: "Neplatné číslo účtu",
		InvalidPersonalIdentificationNumber: "Neplatné rodné číslo",
		InvalidTaxNumber: "Neplatné DIČ",
		InvalidCompanyNumber: "Neplatné IČO",
		IsTrue: "Musí být zaškrtnuto",
		Generic: "Neplatná hodnota",
		NotEmptyValidator: "Vyplňte pole.",
		NotNullValidator: "Vyplňte pole.",
		EmptyValidator: "Pole musí být prázdné.",
		NullValidator: "Pole musí být prázdné.",
		EmailValidator: "E-mail je nevalidní.",
		MinimumLengthValidator: "Hodnota musí mít alespoň {{minLength}} znaků.",
		MaximumLengthValidator: "Hodnota nesmí být delší než {{maxLength}} znaků.",
		LengthValidator: "Hodnota musí mít {{minLength}} až {{maxLength}} znaků.",
		ExactLengthValidator: "Hodnota musí mít přesně {{maxLength}} znaků.",
		RegularExpressionValidator: "Neplatný formát.",
		GreaterThanValidator: "Hodnota musí být větší než {{comparisonValue}}.",
		GreaterThanOrEqualValidator:
			"Hodnota musí být větší nebo rovna {{comparisonValue}}.",
		LessThanValidator: "Hodnota musí být menší než {{comparisonValue}}.",
		LessThanOrEqualValidator:
			"Hodnota musí být menší nebo rovna {{comparisonValue}}.",
		InclusiveBetweenValidator: "Hodnota musí být v rozsahu {{from}} – {{to}}.",
		ExclusiveBetweenValidator:
			"Hodnota musí být mezi {{from}} a {{to}} (vyjma krajních).",
		EqualValidator: "Hodnota musí být rovna {{comparisonValue}}.",
		NotEqualValidator: "Hodnota nesmí být rovna {{comparisonValue}}.",
		PredicateValidator: "Hodnota nesplňuje požadavky.",
		AsyncPredicateValidator: "Hodnota nesplňuje požadavky.",
		CreditCardValidator: "Neplatné číslo platební karty.",
		EnumValidator: "Hodnota není v povoleném seznamu.",
		StringEnumValidator: "Hodnota není v povoleném seznamu.",
		ScalePrecisionValidator:
			"Číslo musí mít max. {{expectedPrecision}} číslic celkem a {{expectedScale}} desetinných míst.",
		Number: {
			Integer: "Musí být celé číslo",
			Min: "Musí být větší nebo rovno {{count}}",
			Max: "Musí být menší nebo rovno {{count}}",
			MoreThen: "Musí být větší než {{count}}",
		},
		String: {
			Min: "Musí být alespoň {{count}} znaků dlouhé.",
			Max: "Nesmí být delší než {{count}} znaků.",
			StrictLength: "Musí obsahovat {{count}} znaků",
			InvalidFormat: "Neplatný formát",
		},
		Array: {
			Min: "Musí obsahovat alespoň {{count}} položku.",
			Min_one: "Musí být vybrána alespoň {{count}} položka.",
			Min_few: "Musí být vybrány alespoň {{count}} položky.",
			Min_other: "Musí být vybráno alespoň {{count}} položek.",
		},
	},
	BlDatePicker: {
		Placeholder: "Vyberte datum",
		PrevYear: "Předchozí rok",
		NextYear: "Další rok",
		Presets: {
			Today: "Dnes",
			Yesterday: "Včera",
			Last7Days: "Posledních 7 dní",
			Last30Days: "Posledních 30 dní",
			ThisMonth: "Tento měsíc",
			LastMonth: "Minulý měsíc",
		},
		Locales: {
			One: "den",
			Two: "dny",
			Few: "dny",
			Other: "dnů",
			Many: "dnů",
			Zero: "dnů",
		},
	},
	Autocomplete: {
		ClearText: "Smazat",
		CloseText: "Zavřít",
		OpenText: "Otevřít",
		NoOptionsText: "Žádné možnosti",
		LoadingText: "Načítání...",
	},
	Table: {
		NoData: "Žádná data",
		NextPage: "Další strana",
		PrevPage: "Předchozí strana",
		RowsPerPage: "Řádků na stránku",
	},
	Sidebar: {
		Dashboard: "Dashboard",
		PathTemplates: "Šablony cest",
		ModuleLibrary: "Knihovna modulů",
		Modelations: "Modelace",
		Methodology: "Metodika",
		Settings: "Nastavení",
		ComingSoon: "Brzy",
		BrandTitle: "Modelační studio",
		BrandSubtitle: "finančního plánu",
		Collapse: "Sbalit menu",
		Expand: "Rozbalit menu",
		LanguageSwitcher: "Jazyk",
	},
	Theme: {
		Toggle: "Přepnout vzhled",
		Light: "Světlý",
		Dark: "Tmavý",
		System: "Systémový",
	},
	Shared: {
		FileUpload: {
			DefaultHelper: "Přetáhněte soubor sem nebo klikněte pro výběr",
			DefaultSubHelper: "Maximální velikost: {{maxMb}} MB",
			Uploading: "Nahrávám…",
			UploadFailed: "Nahrávání souboru selhalo. Zkuste to prosím znovu.",
			FileTooLarge: "Soubor je větší než {{maxMb}} MB.",
			MimeNotAllowed: "Tento typ souboru není povolen.",
			RemoveFile: "Odebrat soubor",
		},
	},
	Modeling: {
		StandaloneModule: {
			PathsHeading: "Cesty obsahující tento modul",
			PathsSubheading:
				"Otevřete tento modul v rámci celé cesty — vyplněné údaje se přenesou.",
			PathsEmpty: "Tento modul není součástí žádné cesty.",
			PathsLoadFailed: "Načtení cest se nezdařilo.",
			OpenInPath: "Otevřít v cestě",
			OpenInPathPending: "Otevírám…",
			StepLabel: "Krok {{order}} – {{name}}",
		},
		ClientSummary: {
			StepHeading: "Shrnutí kroku pro klienta",
			PathHeading: "Souhrnné shrnutí pro klienta",
			ModuleHeading: "Shrnutí pro klienta",
			Placeholder: "Napište vlastní shrnutí pro klienta…",
			Description:
				"Shrnutí se zobrazí klientovi ve sdíleném náhledu a v PDF. Tlačítkem „Vylepšit AI“ ho můžete nechat vylepšit umělou inteligencí.",
			ImproveButton: "Vylepšit AI",
			ImprovePending: "Generuji…",
			Save: "Uložit shrnutí",
			Saving: "Ukládám…",
			SavedToast: "Shrnutí bylo uloženo.",
			DialogTitle: "Návrh shrnutí od AI",
			DialogDescription:
				"Tento text vygenerovala AI z dat kalkulačky a vašeho konceptu. Můžete ho převzít do svého shrnutí, nebo zahodit.",
			Adopt: "Převzít",
			Discard: "Zahodit",
			GenerateFailed:
				"Nepodařilo se vygenerovat shrnutí. Zkuste to prosím znovu.",
			NoData: "Nejprve vyplňte kalkulačku, ať má AI z čeho vycházet.",
			SaveNeedsClient: "Shrnutí lze uložit až po přiřazení klienta.",
		},
		Pdf: {
			GenerateButton: "Generovat PDF",
			GeneratePending: "Generuji PDF…",
			GenerateFailed: "Generování PDF se nezdařilo.",
			Path: {
				Button: "Generovat PDF",
				DialogTitle: "Generovat PDF cesty",
				DialogDescription:
					"Vyber kroky, které se mají vložit do PDF. Výchozí je celá cesta.",
				Generate: "Generovat PDF",
				Generating: "Generuji…",
				Cancel: "Zrušit",
				Empty: "Tato cesta nemá žádné kroky, které lze vložit do PDF.",
				DraftDescription:
					"Cesta zatím není uložená. Vyber klienta — cesta se uloží a hned se vygeneruje PDF.",
				SaveAndGenerate: "Uložit a generovat PDF",
			},
		},
		Share: {
			ShareButton: "Sdílet s klientem",
			SharedBadge: "Sdíleno",
			DialogTitle: "Sdílet modelaci s klientem",
			DialogDescription:
				"Odkaz zobrazí klientovi tuto modelaci v klientském náhledu. Kdokoli s odkazem ji uvidí – bez přihlášení. Odkaz můžete kdykoli zrušit.",
			UrlLabel: "Odkaz pro klienta",
			CopyButton: "Kopírovat",
			CopiedToast: "Odkaz byl zkopírován do schránky.",
			RevokeButton: "Zrušit sdílení",
			RevokePending: "Ruším…",
			SharePending: "Vytvářím odkaz…",
			RevokedToast: "Sdílení bylo zrušeno.",
			ClientRequired: "Modelaci lze sdílet až po přiřazení klienta.",
			CopyFailed: "Kopírování se nezdařilo, zkopírujte odkaz ručně.",
			SendEmailButton: "Odeslat e-mailem",
			SendEmailPending: "Odesílám…",
			SendEmailSentToast: "E-mail s odkazem byl odeslán klientovi.",
		},
		PublicShare: {
			SummaryHeading: "Shrnutí",
			DocumentTitle: "Modelace",
			PreparedBy: "Připravil(a) {{advisor}}",
			NotAvailable: "Modelace není dostupná",
			NotAvailableDescription:
				"Tento odkaz již není platný nebo byl zrušen. Požádejte svého poradce o nový.",
			Loading: "Načítám modelaci…",
			PdfNotAvailable: "Dokument PDF není ve sdíleném náhledu k dispozici.",
			FormNotAvailable: "Tento formulář není ve sdíleném náhledu k dispozici.",
			StepNotSupported: "Tuto část nelze ve sdíleném náhledu zobrazit.",
		},
		Versioning: {
			LoadedOlderVersionTitle: "Načetli jste si starší verzi",
			LoadedOlderVersionBody:
				"Otevřeli jste verzi {{versionNumber}} z {{date}}. Chcete s ní pokračovat (případné úpravy vytvoří novou verzi), nebo přejít na nejnovější?",
			KeepOldButton: "Pokračovat se starou",
			LoadLatestButton: "Načíst nejnovější",
			VersionListLabel: "Verze této modelace",
			VersionItem: "Verze {{n}} • {{date}}",
			LatestBadge: "aktuální",
			ForkedToast: "Vytvořena nová verze {{n}}",
		},
		CustomModules: {
			Heading: "Vlastní moduly",
			UploadPdfButton: "Nahrát PDF",
			NewPdfPageTitle: "Nový PDF modul",
			NewPdfPageSubtitle:
				"Nahrajte PDF a pojmenujte ho — bude k dispozici v knihovně modulů.",
			EditPageTitle: "Upravit modul",
			EditPageSubtitle:
				"Změňte název, popis nebo nahraďte soubor. Změny se projeví ve všech cestách, kde je modul použit.",
			NameLabel: "Název modulu",
			NamePlaceholder: "Např. Úvodní představení firmy",
			DescriptionLabel: "Popis (volitelný)",
			DescriptionPlaceholder: "Krátký popis pro vás a kolegy",
			PdfFileLabel: "PDF soubor",
			PdfFileHint: "Maximální velikost 20 MB. Povolený formát: PDF.",
			PdfDropzoneHelper: "Přetáhněte PDF sem nebo klikněte pro výběr",
			PdfDropzoneSubHelper: "Maximální velikost: {{maxMb}} MB",
			ScopeLabel: "Sdílení",
			ScopeDescription:
				"Soukromý modul vidíte jen vy. Sdílený s organizací mají k dispozici všichni poradci ve vašem tenantu.",
			ScopePersonal: "Soukromý",
			ScopeTenant: "Sdílený s organizací",
			ScopeSystem: "Systémový",
			ScopeSystemDescription:
				"Systémový modul vidí všichni napříč organizacemi. Mohou ho vytvářet a upravovat pouze správci systému.",
			SaveButton: "Uložit modul",
			SavingButton: "Ukládám…",
			DeleteButton: "Smazat modul",
			DeleteConfirm: "Opravdu smazat tento modul?",
			DeleteSuccess: "Modul byl smazán.",
			DeleteInUseError:
				"Modul nelze smazat — je použit v existujících šablonách nebo cestách. Nejdřív ho z nich odeberte.",
			BackToLibrary: "Zpět do knihovny modulů",
			CategoryCustomModules: "Vlastní moduly",
			AddFormButton: "Přidat formulář",
			FormCardSubtitleSingular: "{{count}} pole",
			FormCardSubtitleFew: "{{count}} pole",
			FormCardSubtitleMany: "{{count}} polí",
		},
		Forms: {
			Builder: {
				PageTitleNew: "Nový formulář",
				PageTitleEdit: "Upravit formulář",
				SubtitleNew:
					"Sestavte formulář z prvků — přetáhněte je z levého panelu na plátno.",
				SubtitleEdit:
					"Změňte název, popis nebo strukturu polí. Změny se projeví v cestách, kde je formulář použit.",
				NameLabel: "Název formuláře",
				NamePlaceholder: "Např. Vstupní rozhovor s klientem",
				NameRequired: "Zadejte název formuláře.",
				DescriptionLabel: "Popis (volitelný)",
				DescriptionPlaceholder: "Krátký popis pro vás a kolegy",
				SaveButton: "Uložit formulář",
				SavingButton: "Ukládám…",
				CancelButton: "Zrušit",
				DeleteButton: "Smazat formulář",
				DeleteConfirm: "Opravdu smazat tento formulář?",
				DeleteSuccess: "Formulář byl smazán.",
				DiscardConfirm: "Máte neuložené změny. Opravdu odejít?",
				LeftPanel: {
					Heading: "Prvky formuláře",
					SystemFieldsHeading: "Systémové prvky",
					CustomFieldsHeading: "Vlastní prvky",
					Empty: "Žádné dostupné prvky. Kontaktujte vývojový tým.",
				},
				Center: {
					EmptyHint: "Přetáhněte sem prvky z levého panelu",
					RemoveField: "Odebrat prvek",
					DragHandle: "Přesunout prvek",
					FieldIndex: "Pole {{index}}",
					SystemBadge: "Systémový",
					CustomBadge: "Vlastní",
					AutoLabelPrefix: "Otázka",
				},
				Right: {
					EmptyHint: "Vyberte prvek pro úpravu",
					SystemFieldHint: "Systémový prvek — bez nastavení v této verzi.",
					DataTypeLabel: "Datový typ",
					LabelLabel: "Popisek",
					LabelPlaceholder: "Zadejte text otázky",
					LabelHint:
						"Co se zobrazí klientovi nad vstupním polem. Můžete kdykoli změnit.",
				},
				SystemFieldLabel: {
					MonthlyIncome: "Měsíční příjem",
					MonthlyExpenses: "Měsíční výdaje",
					ClientIdentity: "Identifikace klienta",
					ClientGoals: "Cíle klienta",
					MeetingNote: "Poznámka ze schůzky",
					ClientFirstName: "Jméno",
					ClientLastName: "Příjmení",
					ClientJob: "Zaměstnání",
					ClientAge: "Věk",
					ClientBirthDate: "Datum narození",
					ClientBirthPlace: "Místo narození",
					ClientAddress: "Adresa",
					ClientEmail: "E-mail",
					ClientPhone: "Telefon",
				},
				DataType: {
					Composite: "Strukturovaná data",
					Numeric: "Číslo",
					Text: "Text",
					Date: "Datum",
					Money: "Peníze (Kč)",
					Percent: "Procenta",
					Address: "Adresa",
					Email: "E-mail",
					Phone: "Telefon",
				},
				CustomFieldLabel: {
					ShortText: "Krátký text",
				},
				CustomFieldDescription: {
					ShortText: "Jednořádkové textové pole pro krátkou odpověď.",
				},
				FieldDefaultLabel: "Otázka {{index}}",
				AddressLabels: {
					Type: "Typ adresy",
					Street: "Ulice",
					HouseNumber: "Číslo popisné",
					City: "Město",
					Zip: "PSČ",
					Country: "Stát",
					TypePlaceholder: "Vyberte typ adresy",
					ZipInvalid: "PSČ musí mít 5 číslic.",
					CountryPlaceholder: "Vyberte nebo zadejte stát",
				},
				AddressType: {
					Permanent: "Trvalá",
					Contact: "Kontaktní",
				},
				FieldValidation: {
					InvalidEmail: "Neplatný formát e-mailu.",
					InvalidPhone:
						"Neplatný formát telefonního čísla (např. +420 777 123 456 nebo 777123456).",
				},
			},
		},
		Common: {
			Loading: "Načítám…",
			LoadingFailed: "Načtení se nezdařilo.",
			SaveSuccess: "Uloženo.",
			Computing: "Počítám…",
			AdvisorView: "Poradenská",
			ClientView: "Klientská",
			LayerToggleHint: "Přepínač pohledu na modelaci",
			LayerToggleAdvisorHint: "Vidíte vstupy a výpočet — to, co uvidíte vy.",
			LayerToggleClientHint: "Vidíte hlavní pointu — to, co uvidí klient.",
			AssumptionsTitle: "S čím v kalkulaci počítáme",
			InputsTitle: "Vstupy modelace",
			EmptyResult: "Po vyplnění vstupů se zobrazí výsledek modelace.",
			BackLabel: "Zpět",
			ModuleLibraryBackLabel: "Knihovna modulů",
			CategoryTimelineLabel: "Moduly kategorie",
			StepPrevLabel: "Zpět",
			StepNextLabel: "Pokračovat",
			MortgageStartTooltip: "Start splácení",
			SavingStartTooltip: "Start spoření",
			Changes: {
				Heading: "Změny částky",
				Add: "Přidat změnu",
				Show: "Zobrazit změny",
				Hide: "Skrýt změny",
				Remove: "Odstranit změnu",
				Type: "Typ změny",
				TypeMoment: "Datum",
				TypeEvent: "Událost",
				Event: "Vyberte událost",
				Date: "Od kdy",
				Value: "Nová částka (Kč)",
				MinimalValue: "Nové povinné minimum (Kč)",
				NoEvents:
					"Nejsou definovány žádné události — přidejte je v sekci „Plánované události“.",
			},
			TaxBasisOptions: {
				Real: "Z rozdílu příjmů a výdajů",
				Flat1: "1. pásmo paušální daně",
				Flat2: "2. pásmo paušální daně",
				Flat3: "3. pásmo paušální daně",
			},
		},
		ClientLayer: {
			Heading: "Klientská vrstva",
			Description:
				"V MVP řešíme primárně poradenskou vrstvu. Klientský pohled je architektonicky připravený — narativní UI doplníme v další iteraci.",
		},
		LaunchMode: {
			PathTitle: "Spustit cestu",
			ModuleTitle: "Spustit modelaci",
			Description: "Chcete pracovat s konkrétním klientem, nebo bez něj?",
			WithClientButton: "Načíst data konkrétního klienta",
			WithClientHint: "Vyhledat v SAB a načíst klientovy údaje do cesty.",
			WithoutClientButton: "Vyplňovat bez klienta",
			WithoutClientHint: "Modelaci spustíte naprázdno (nácvik / demo).",
			SearchPlaceholder: "Jméno, e-mail nebo RČ…",
			Searching: "Hledám…",
			NoResults: "Žádní klienti nenalezeni.",
			MinCharsHint: "Začněte psát (min. 2 znaky)…",
			BackToChoice: "Zpět",
			ContinueWithoutClient: "Pokračovat bez klienta",
			ClientBadgeLabel: "Klient",
			Switcher: {
				Title: "Aktivní klient",
				NoClient: "Bez klienta · Vybrat klienta",
				SelectedPrefix: "Klient",
				Change: "změnit",
				Clear: "Odpojit klienta",
			},
		},
		AnonymousLeave: {
			Title: "Uložit modelaci pod klienta?",
			Body: "Pracujete bez vybraného klienta. Pokud chcete tuto modelaci zachovat, vyberte klienta, pod kterého se má uložit.",
			PickedClientLabel: "Vybraný klient",
			SaveButton: "Uložit pod tohoto klienta",
			DiscardButton: "Neukládat, odejít",
			CancelButton: "Pokračovat editovat",
			SaveFailedToast: "Nepodařilo se uložit modelaci, zkuste to znovu.",
			SavedToast: "Modelace uložena pod klienta {{clientName}}.",
			RequiresClientStep:
				"Tento krok můžete vyplnit až po přiřazení modelace ke klientovi. Pokračujte na dalším kroku nebo modelaci uložte pod konkrétního klienta.",
		},
		Library: {
			PageTitle: "Knihovna modulů",
			Heading: "Modelační moduly",
			Subheading: "Knihovna",
			Description:
				"Spusťte jednotlivý modul samostatně, nebo si z modulů složte cestu — kombinujte je do předpisu, který jde znovu pustit pro každého klienta.",
			OpenModule: "Otevřít modelaci",
			ModuleCountSingular: "modul",
			ModuleCountFew: "moduly",
			ModuleCountMany: "modulů",
			Filters: {
				SearchLabel: "Hledat",
				SearchPlaceholder: "Název nebo popis modulu…",
				CategoryLabel: "Kategorie",
				CategoryAll: "Všechny kategorie",
				TypeLabel: "Typ modulu",
				TypeAll: "Všechny typy",
				TypeCalculator: "Kalkulačky",
				TypeForm: "Formuláře",
				TypePdf: "PDF",
				ScopeAll: "Vše",
				ScopeSystem: "Systémové",
				ScopeTenant: "Firemní",
				ScopePersonal: "Moje",
				ResultsCount: "{{filtered}} z {{total}} modulů",
				ResetFilters: "Vymazat filtry",
				EmptyFilter:
					"Žádné moduly neodpovídají filtru. Zkuste jiný hledaný výraz nebo kategorii.",
			},
		},
		MiniCalculators: {
			OptimalMortgagePeriod: {
				TriggerAriaLabel: "Kalkulátor optimální splatnosti",
				Title: "Optimální splatnost hypotéky",
				MortgageAfterLabel: "Hypotéka za (doba spoření, roky)",
				ClientAgeLabel: "Věk klienta",
				ResultLabel: "Optimální splatnost",
				ResultYears: "{{years}} let",
			},
			RentGetGrossIncome: {
				TriggerAriaLabel: "Spočítat hrubý příjem z čistého",
				Title: "Přepočet z čistého na hrubý",
				NetIncomeLabel: "Čistý měsíční příjem",
				ResultLabel: "Hrubý měsíční příjem",
				Apply: "Použít",
				HelperText:
					"Zjednodušený přepočet — počítá se, jako by celý čistý příjem pocházel ze zaměstnání.",
			},
			RentGetNetIncome: {
				TriggerAriaLabel: "Spočítat čistý příjem z hrubého",
				Title: "Přepočet z hrubého na čistý",
				GrossIncomeLabel: "Hrubý měsíční příjem",
				ResultLabel: "Čistý měsíční příjem",
				Apply: "Použít",
				HelperText:
					"Zjednodušený přepočet — počítá se, jako by celý hrubý příjem pocházel ze zaměstnání.",
			},
			RentGetMonthlyInvestment: {
				TriggerAriaLabel: "Spočítat potřebnou výši měsíční investice",
				Title: "Doporučená měsíční investice",
				Description:
					"Spočítat potřebnou výši měsíční investice pro dosažení potřebné částky (při zachování aktuální jednorázové investice).",
				ResultLabel: "Výše měsíční investice",
				Apply: "Použít",
			},
			RentGetOneTimeInvestment: {
				TriggerAriaLabel: "Spočítat potřebnou výši jednorázové investice",
				Title: "Doporučená jednorázová investice",
				Description:
					"Spočítat potřebnou výši jednorázové investice pro dosažení potřebné částky (při zachování aktuální pravidelné investice).",
				ResultLabel: "Výše jednorázové investice",
				Apply: "Použít",
			},
			PresentValueFromAcquisition: {
				TriggerAriaLabel: "Kalkulátor současné hodnoty",
				Title: "Odhad současné hodnoty",
				Description:
					"Spočítat odhad současné hodnoty nemovitosti na základě průměrného vývoje cen v ČR.",
				ResultLabel: "Odhad současné hodnoty",
			},
		},
		InfoTooltips: {
			MonthlyEvaluation: {
				TriggerAriaLabel: "Měsíční zhodnocení",
				Title: "Měsíční zhodnocení:",
			},
		},
		Modules: {
			FinancialBalanceFinancialBalance: {
				Title: "Finanční bilance",
				Subtitle:
					"Přehled příjmů, výdajů a životních událostí v čase. Bilance domácnosti rok po roce.",
				ShortDescription:
					"Příjmy, výdaje, plánované životní události → vývoj bilance v čase.",
				Category: "Finanční bilance",
				ExpenseCategories: {
					Housing: "Bydlení",
					Transport: "Doprava",
					Savings: "Spoření",
					Insurance: "Pojištění",
					Household: "Domácnost",
					Taxes: "Daně",
					Other: "Ostatní",
				},
				Sections: {
					Incomes: "Moje příjmy",
					Expenses: "Moje výdaje",
					Events: "Plánované události",
					Chart: "Vývoj příjmů a výdajů",
				},
				Inputs: {
					IncomesTitle: "Moje příjmy",
					ExpensesTitle: "Moje výdaje",
					EventsTitle: "Plánované události",
					AddIncome: "Přidat příjem",
					AddExpense: "Přidat výdaj",
					AddEvent: "Přidat událost",
					RemoveRow: "Odstranit řádek",
					IncomeRowName: "Název",
					IncomeRowValue: "Měsíčně (Kč)",
					ExpenseRowName: "Název",
					ExpenseRowValue: "Měsíčně (Kč)",
					ExpenseRowMinimalValue: "Povinné minimum (Kč)",
					ExpenseRowCategory: "Kategorie",
					ExpenseRowType: "Typ",
					ExpenseTypeMandatory: "Povinný",
					ExpenseTypeVoluntary: "Nepovinný",
					EventRowName: "Název události",
					EventRowDate: "Datum",
					ChartStartYear: "Od",
					ChartEndYear: "Do",
				},
				Metrics: {
					TotalIncomes: "Celkem příjmy",
					TotalExpenses: "Celkem výdaje",
					Difference: "Rozdíl příjmů a výdajů",
					IncomeRowLabel: "{{index}}. příjem",
					ExpenseRowLabel: "{{index}}. výdaj",
					EventRowLabel: "{{index}}. událost",
					ChangeRowLabel: "{{index}}. změna",
				},
				Client: {
					ContextLabel: "Jak se vyvíjí má bilance?",
					Pointe:
						"Tabulka ukazuje vývoj příjmů a výdajů v dalších letech — zelená plocha je váš prostor pro investice.",
				},
				Chart: {
					Title: "Vývoj příjmů a výdajů",
					SeriesDifference: "Rozdíl mezi příjmy a výdaji",
					SeriesTotalIncomes: "Celkové příjmy",
					SeriesTotalExpenses: "Celkové výdaje",
					TooltipDifference: "Příjmy - výdaje",
					AriaLabel: "Graf vývoje příjmů a výdajů domácnosti v čase",
				},
			},
			FinancialBalanceIncomes: {
				Title: "Příjmy",
				Subtitle:
					"Detailní pohled na jednotlivé příjmy domácnosti a jejich vývoj v čase.",
				ShortDescription:
					"Seznam příjmů domácnosti + graf vývoje každého z nich.",
				Category: "Finanční bilance",
				IncomesTitle: "Moje příjmy",
				NoIncomes:
					"Zatím nemáte zadané žádné příjmy. Přidejte je na obrazovce „Finanční bilance“.",
				Sections: {
					Events: "Plánované události",
				},
				Metrics: {
					TotalIncomes: "Celkem příjmy",
					IncomeRowLabel: "{{index}}. příjem",
					EventRowLabel: "{{index}}. událost",
					ChangeRowLabel: "{{index}}. změna",
				},
				Chart: {
					Title: "Vývoj příjmů v čase",
					AriaLabel: "Graf vývoje jednotlivých příjmů v čase",
				},
				Client: {
					ContextLabel: "Jaké jsou mé příjmy?",
					Pointe: "Detailní pohled na jednotlivé zdroje příjmu.",
				},
			},
			FinancialBalanceExpenses: {
				Title: "Výdaje",
				Subtitle:
					"Detailní pohled na výdaje s možností filtrace na povinné minimum.",
				ShortDescription:
					"Seznam výdajů s filtrací povinné/všechny + graf vývoje.",
				Category: "Finanční bilance",
				ExpensesTitle: "Moje výdaje",
				NoExpenses:
					"Zatím nemáte zadané žádné výdaje. Přidejte je na obrazovce „Finanční bilance“.",
				Sections: {
					Filter: "Filtr výdajů",
					Events: "Plánované události",
				},
				Inputs: {
					FilterLabel: "Zobrazené výdaje",
					ExpenseTypeAll: "Všechny výdaje",
					ExpenseTypeMandatory: "Povinné výdaje",
				},
				Metrics: {
					TotalExpenses: "Celkem výdaje",
					ExpenseRowLabel: "{{index}}. výdaj",
					EventRowLabel: "{{index}}. událost",
					ChangeRowLabel: "{{index}}. změna",
				},
				Chart: {
					Title: "Vývoj výdajů v čase",
					AriaLabel: "Graf vývoje jednotlivých výdajů v čase",
				},
				Client: {
					ContextLabel: "Jaké jsou mé výdaje?",
					Pointe:
						"Přepínačem nahoře vidíte buď všechny výdaje, nebo jen povinné minimum.",
				},
			},
			FinancialBalanceCompare: {
				Title: "Porovnání",
				Subtitle:
					"Stav rozpočtu v konkrétním okamžiku — vyberte událost nebo aktuální měsíc.",
				ShortDescription:
					"Bod v čase, ruční skrytí řádků, srovnání kategorií příjmů vs. výdajů.",
				Category: "Finanční bilance",
				IncomesTitle: "Moje příjmy",
				ExpensesTitle: "Moje výdaje",
				NoIncomes: "Žádné viditelné příjmy.",
				NoExpenses: "Žádné viditelné kategorie výdajů.",
				HideRow: "Skrýt řádek",
				CurrentMonth: "Aktuální měsíc",
				Sections: {
					Filter: "Okamžik porovnání",
					Incomes: "Moje příjmy",
					Expenses: "Moje výdaje",
				},
				Inputs: {
					MomentSelect: "Okamžik",
					FilterLabel: "Zobrazené výdaje",
					ExpenseTypeAll: "Všechny výdaje",
					ExpenseTypeMandatory: "Povinné výdaje",
				},
				Metrics: {
					FilteredTotalIncomes: "Celkem příjmy",
					FilteredTotalExpenses: "Celkem výdaje",
					Difference: "Rozdíl příjmů a výdajů",
				},
				Chart: {
					Title: "Srovnání příjmů a výdajů",
					XCategoryIncomes: "Příjmy",
					XCategoryExpenses: "Výdaje",
					AriaLabel: "Sloupcový graf porovnání příjmů a výdajů domácnosti",
				},
				Client: {
					ContextLabel: "Jak vypadá bilance v daném okamžiku?",
					Pointe:
						"Vyberte plánovanou událost a uvidíte, jak vypadá bilance domácnosti od toho data.",
				},
			},
			HousingMortgage: {
				Title: "Hypotéka",
				Subtitle:
					"Klasický splátkový kalkulátor — vstup je pořizovací cena, výstup měsíční splátka a graf vývoje jistiny.",
				ShortDescription:
					"Z pořizovací ceny spočítá splátku úvěru s ohledem na LTV a zajištění.",
				Category: "Bydlení",
				Inputs: {
					PurchasePrice: "Pořizovací cena",
					Period: "Splatnost úvěru",
					InterestRate: "Úroková sazba (p.a.)",
					IsLtvEnabled: "Počítat s LTV",
					MaxLtv: "Maximální LTV",
					PriceEstimation: "Zajištění (odhad ceny)",
				},
				Metrics: {
					Payment: "Splátka úvěru",
					MaximumLoanAmount: "Maximální výše úvěru",
				},
				Client: {
					ContextLabel: "Kolik budu měsíčně splácet?",
					Pointe: "Měsíční splátka úvěru.",
				},
				Chart: {
					Title: "Vývoj jistiny",
					Principal: "Jistina",
					TypeBar: "Sloupcový",
					TypeLine: "Spojnicový",
					TypeToggleAriaLabel: "Typ grafu",
					YearLabel: "{{year}}. rok",
					AriaLabel: "Graf vývoje jistiny hypotéky",
				},
			},
			HousingOwnSources: {
				Title: "Vlastní zdroje",
				Subtitle:
					"Pomáhá klientovi naplánovat dospoření vlastních zdrojů na pořízení bydlení.",
				ShortDescription:
					"Kolik měsíčně či jednorázově dorovnat, aby klient měl vlastní zdroje.",
				Category: "Bydlení",
				Inputs: {
					RequiredOwnSource: "Potřebná výše vlastních zdrojů",
					Period: "Doba spoření",
					AnnualEvaluation: "Očekávané zhodnocení",
					CalculateRequiredInvestment: "Dopočítat potřebné investice",
					StartingInvestment: "Počáteční investice",
					MonthlyInvestment: "Měsíční investice",
				},
				Metrics: {
					RequiredRegularInvestment: "Potřebná měsíční investice",
					RequiredOneTimeInvestment: "Potřebná jednorázová investice",
					RequiredIncreaseOfRegularInvestment:
						"Potřebné navýšení měsíční investice",
					RequiredIncreaseOfOneTimeInvestment:
						"Potřebné navýšení jednorázové investice",
				},
				Chart: {
					Title: "Vývoj naspořené částky",
					RegularInvestment: "Měsíční investice",
					OneTimeInvestment: "Jednorázová investice",
					StartingInvestment: "Počáteční investice",
					IncreaseOfRegularInvestment: "Navýšení měsíční investice",
					IncreaseOfOneTimeInvestment: "Navýšení jednorázové investice",
					TypeBar: "Sloupcový",
					TypeLine: "Spojnicový",
					TypeToggleAriaLabel: "Typ grafu",
					YearLabel: "{{year}}. rok",
					SavingStart: "Start spoření",
					AriaLabel: "Graf vývoje naspořené částky",
				},
				Client: {
					ContextLabel: "Jak naspořím vlastní zdroje?",
					Pointe:
						"Stačí si měsíčně odkládat tuto částku a budete mít vlastní zdroje včas.",
				},
			},
			HousingRentVsMortgage: {
				Title: "Proč hypotéku",
				Subtitle:
					"Ukazuje, že za ekvivalent dnešního nájmu (+ marginální navýšení) klient dokáže financovat vlastní bydlení.",
				ShortDescription:
					"Nájem vs. budování majetku — kolik klient zaplatí na nájmu za 30 let.",
				Category: "Bydlení",
				Inputs: {
					Rent: "Výše dnešního nájmu",
					MaximalPayment: "Maximální výše splátky HÚ",
					InterestRate: "Úroková sazba HÚ",
					Period: "Splatnost úvěru",
					AreOwnResourcesEnabled: "Naspořit vlastní zdroje",
					OwnResources: "Vlastní zdroje",
					Ltv: "LTV",
				},
				Metrics: {
					MaximumLoanAmount: "Maximální pořizovací cena nemovitosti",
					Payment: "Při splátce",
				},
				Client: {
					ContextLabel: "Kolik bych si mohl dovolit, když platím nájem?",
					Pointe:
						"Při dnešním nájmu a vaší zvládnutelné splátce zvládnete pořídit nemovitost.",
				},
				Chart: {
					Title: "Splácení hypotéky",
					Principal: "Jistina",
					OwnSources: "Vlastní zdroje",
					TypeBar: "Sloupcový",
					TypeLine: "Spojnicový",
					TypeToggleAriaLabel: "Typ grafu",
					YearLabel: "Rok {{year}}",
					AriaLabel: "Vývoj zůstatku hypotéky v čase",
				},
			},
			HousingRefinancing: {
				Title: "Refinancování",
				Subtitle:
					"Splátka úvěru po fixaci — buď stejná splátka s delší splatností, nebo nižší splátka při zachování splatnosti.",
				ShortDescription:
					"Co se stane se splátkou hypotéky po skončení fixace.",
				Category: "Bydlení",
				Inputs: {
					LoanAmount: "Výše úvěru",
					Period: "Splatnost úvěru",
					InterestRate: "Úroková sazba (p.a.)",
					Fixation: "Fixace",
					InterestRateAfterFixation: "Úroková sazba po fixaci (p.a.)",
				},
				Metrics: {
					Payment: "Splátka úvěru",
					LoanAmountAfterFixation: "Zůstatek úvěru po fixaci",
					KeepPaymentHeading: "zachování původní splátky",
					KeepPeriodHeading: "zachování původní splatnosti",
					NewPeriod: "Nová splatnost",
					NewPayment: "Nová splátka úvěru",
					OriginalPeriodAfterFixation: "Zbývající splatnost po fixaci",
				},
				Client: {
					ContextLabel: "Co s hypotékou po fixaci?",
					Pointe:
						"Po fixaci se sazba mění — splátku můžete zachovat (zkrátí se doba splácení) nebo zachovat splatnost (sníží se splátka).",
				},
				Chart: {
					Title: "Splácení hypotéky",
					ShowChart: "Zobrazit graf refinancování",
					HideChart: "Skrýt graf refinancování",
					BeforeFixation: "Původní úvěr",
					AfterFixationSamePayment: "Úvěr při stejné splátce",
					AfterFixationSamePeriod: "Úvěr při stejné splatnosti",
					TypeBar: "Sloupcový",
					TypeLine: "Spojnicový",
					TypeToggleAriaLabel: "Typ grafu",
					YearLabel: "Rok {{year}}",
					AriaLabel: "Vývoj zůstatku hypotéky před a po fixaci",
				},
			},
			HousingExtraPayments: {
				Title: "Mimořádné splátky",
				Subtitle:
					"Vliv mimořádných splátek na zůstatek úvěru a délku splácení.",
				ShortDescription:
					"Kolik ušetříte mimořádnými splátkami a o kolik se zkrátí doba splácení.",
				Category: "Bydlení",
				Sections: {
					ExtraPayments: "Mimořádné splátky",
				},
				Inputs: {
					PurchasePrice: "Výše úvěru",
					Period: "Splatnost úvěru",
					InterestRate: "Úroková sazba (p.a.)",
					PaymentsEnabled: "Počítat s mimořádnými splátkami",
					RowPayment: "Výše splátky",
					RowAfter: "Za kolik let",
					RowKeepPeriod: "Úprava financování",
					KeepPaymentOption: "Ponechat splátku",
					KeepPeriodOption: "Ponechat splatnost",
				},
				Metrics: {
					Payment: "Splátka úvěru",
					RowRemainingPayment: "Nová splátka",
					RowRemainingPeriod: "Zbývající splatnost",
					RowLabel: "{{index}}. splátka",
				},
				Buttons: {
					AddPayment: "Přidat splátku",
					RemovePayment: "Odebrat splátku",
				},
				Client: {
					ContextLabel: "Mimořádné splátky hypotéky",
					Pointe:
						"Mimořádnými splátkami snížíte splátku nebo zkrátíte délku úvěru — a ušetříte na úrocích.",
				},
				Chart: {
					Title: "Splácení hypotéky",
					Principal: "Jistina",
					TypeBar: "Sloupcový",
					TypeLine: "Spojnicový",
					TypeToggleAriaLabel: "Typ grafu",
					YearLabel: "Rok {{year}}",
					AriaLabel: "Vývoj zůstatku hypotéky v čase",
				},
			},
			HousingRedeemMortgage: {
				Title: "Předčasné splacení",
				Subtitle: "Kdy lze hypotéku doplatit z naspořené investice.",
				ShortDescription:
					"Investice paralelně se splácením — za kolik let lze hypotéku doplatit.",
				Category: "Bydlení",
				Inputs: {
					PurchasePrice: "Výše úvěru",
					Period: "Splatnost úvěru",
					InterestRate: "Úroková sazba (p.a.)",
					OnetimeInvestment: "Jednorázová investice",
					MonthInvestment: "Měsíční investice",
					Evaluation: "Zhodnocení",
				},
				Metrics: {
					Payment: "Splátka úvěru",
					Amortisation: "Lze doplatit za",
					AmortisationNever: "V rámci splatnosti nelze doplatit",
				},
				Client: {
					ContextLabel: "Kdy lze hypotéku doplatit?",
					Pointe:
						"Investice paralelní se splácením hypotéky umožní doplatit úvěr dříve, než vyprší splatnost.",
				},
				Chart: {
					Title: "Hypotéka vs. investice",
					Loan: "Jistina",
					Investment: "Investice",
					AmortisationMarker: "Možnost splacení",
					TypeBar: "Sloupcový",
					TypeLine: "Spojnicový",
					TypeToggleAriaLabel: "Typ grafu",
					YearLabel: "Rok {{year}}",
					AriaLabel: "Porovnání zůstatku hypotéky a investice v čase",
				},
			},
			HousingHousingOverview: {
				Title: "Kompletní modelace",
				Subtitle:
					"Komplexní bytová modelace — LTV, vlastní zdroje, refinancování, paralelní investice a mimořádné splátky.",
				ShortDescription: "Kompletní model bydlení v jedné kalkulačce.",
				Category: "Bydlení",
				PresavingYearTooltip: "Předspoření - {{year}}. rok",
				Inputs: {
					PurchasePrice: "Pořizovací cena",
					Period: "Splatnost úvěru",
					InterestRate: "Úroková sazba (p.a.)",
					IsLtvEnabled: "Počítat s LTV?",
					MaxLtv: "Maximální LTV",
					PriceEstimation: "Zajištění (odhad ceny)",
					CalculateRequiredInvestment: "Naspořit vlastní zdroje?",
					CalculateRequiredInvestmentDisabledTooltip:
						"Tato část je aktivní pouze v případě, že je výše úvěru nižší než pořizovací cena. Rozdílných hodnot lze docílit využitím výpočtu se zahrnutím LTV.",
					RequiredOwnSource: "Potřebná výše vlastních zdrojů",
					SavingPeriod: "Doba spoření",
					SavingAnnualEvaluation: "Očekávané zhodnocení p.a.",
					MonthlySaving: "Měsíční investice",
					OneTimeSaving: "Jednorázová investice",
					UseBalance: "Využít zůstatek",
					UseBalanceYes: "Ano",
					UseBalanceNo: "Ne",
					EnableRefinancing: "Změna sazby (refinancování)?",
					RefinancingAfter: "Změna sazby za",
					RefinancingInterestRate: "Nová úroková sazba p.a.",
					RefinancingKeepPeriod: "Úprava financování",
					ParallelInvestment: "Investice?",
					MonthlyInvestment: "Měsíční investice",
					OneTimeInvestment: "Jednorázová investice",
					InvestmentAnnualEvaluation: "Očekávané zhodnocení p.a.",
					EnablePayments: "Mimořádné splátky?",
					PaymentValue: "Výše splátky",
					PaymentAfter: "Za kolik let",
					PaymentSource: "Zdroj",
					PaymentKeepPeriod: "Úprava financování",
					KeepPaymentOption: "Ponechat splátku",
					KeepPeriodOption: "Ponechat splatnost",
					SourceInvesting: "Investice",
					SourceOther: "Jiný",
				},
				Metrics: {
					Payment: "Splátka úvěru",
					MaximumLoanAmount: "Maximální výše úvěru",
					RequiredRegularSaving: "Potřebné navýšení měsíční investice",
					RequiredOneTimeSaving: "Potřebné navýšení jednorázové investice",
					OwnSource: "Vlastní zdroje",
					OwnSourceShortage: "Nemáte naspořeno dostatek vlastních zdrojů",
					Amortisation: "Předčasně splatit lze za",
					BalanceOfOwnSource: "Zůst. vl. zdrojů: {{amount}}",
					RowRemainingPayment: "Zbývající splátka",
					RowRemainingPeriod: "Zbývající splatnost",
					RowAvailableAmount: "k dispozici {{amount}}",
					RefinancingRowLabel: "{{index}}. refinancování",
					PaymentRowLabel: "{{index}}. mimořádná splátka",
				},
				Buttons: {
					AddRefinancing: "Přidat refinancování",
					RemoveRefinancing: "Odebrat refinancování",
					AddPayment: "Přidat splátku",
					RemovePayment: "Odebrat splátku",
				},
				Client: {
					ContextLabel: "Kompletní modelace bydlení",
					Pointe:
						"Komplexní pohled na hypotéku — LTV, vlastní zdroje, refinancování, paralelní investice i mimořádné splátky v jedné modelaci.",
				},
				Chart: {
					Title: "Kompletní modelace bydlení",
					Loan: "Jistina",
					Saving: "Investice předspoření",
					Investment: "Souběžná investice",
					AmortisationMarker: "Možnost splacení",
					TypeBar: "Sloupcový",
					TypeLine: "Spojnicový",
					TypeToggleAriaLabel: "Typ grafu",
					YearLabel: "Rok {{year}}",
					AriaLabel: "Vývoj zůstatku úvěru, spoření a investic v čase",
				},
				Sections: {
					Ltv: "LTV",
					OwnSources: "Vlastní zdroje",
					Refinancing: "Refinancování",
					Investment: "Paralelní investice",
					ExtraPayments: "Mimořádné splátky",
				},
			},
			UnderinsuranceOverview: {
				Title: "Pojistné krytí",
				Subtitle:
					"Co dostanu z pojistky, když mi vznikne škoda na nemovitosti?",
				ShortDescription:
					"Porovnání pojistné částky a aktuální hodnoty nemovitosti — kolik pojišťovna vyplatí a kolik bude chybět.",
				Category: "Podpojištění",
				Inputs: {
					PurchasePrice: "Pojistná částka",
					PresentValue: "Pojistná hodnota dnes",
					CausedDamagePercentage: "Vzniklá škoda na majetku",
				},
				Visual: {
					Title: "Pojistné krytí",
					LeftTitle: "pojistné krytí v době sjednání pojištění",
					RightTitle: "pojistné krytí nyní",
					CausedDamageLabel: "Vzniklá škoda",
					IndemnityLabel: "Pojistné plnění",
					ShortfallLabel: "Chybějící částka",
				},
				Client: {
					ContextLabel: "Kolik pojišťovna vyplatí při škodě?",
					Pointe:
						"Výše pojistného plnění odpovídá poměru pojistné částky vůči současné hodnotě nemovitosti.",
				},
			},
			RentMyRent: {
				Title: "Můj důchod",
				Subtitle:
					"Odhad budoucího starobního důchodu vs. čistý příjem klienta při zachování inflačního růstu.",
				ShortDescription:
					"Kolik dostanu od státu a o kolik se sníží můj příjem v důchodu?",
				Category: "Důchod",
				Sections: {
					Inputs: "Vstupy",
					Pension: "Důchod",
				},
				Inputs: {
					NetIncome: "Čistý měsíční příjem",
					ClientAge: "Věk klienta",
					RetirementAge: "Odchod do důchodu",
					IncludedYears: "Započtená doba pojištění",
					Inflation: "Inflace",
					CustomPensionEnabled: "Vlastní výše důchodu",
					CustomPensionEnabledTooltip:
						"Vypočítaný důchod můžete nahradit zadanou částkou. Výpočet důchodu neproběhne a bude se pracovat pouze se zde zadanou částkou.",
					CustomPensionValue: "Vlastní částka důchodu",
					CountOnRentFromState: "Spočítat důchod od státu",
					CountOnRentFromStateTooltip:
						"Důchod je zjednodušeně počítán z hrubého přímu a základu daně OSVČ. Uveďte pouze příjmy ze zdrojů, které se vás týkají, u ostatních nechejte výši příjmu 0.",
					GrossIncome: "Hrubý měsíční příjem",
					GrossIncomeTooltip:
						"Při kliknutí na ikonu kalkulačky se provede zjednodušený přepočet z uvedeného čistého příjmu na hrubý měsíční příjem zaměstnance. Při výpočtu není zohledněn základ daně OSVČ, počítá se, jako by celý čistý příjem pocházel ze zaměstnání.",
					TaxBaseMode: "Způsob výpočtu vyměřovacího základu",
					AverageAnnualTaxBase: "Prům. roční základ daně OSVČ",
				},
				Metrics: {
					DecreasedPensionIncome: "O kolik se sníží můj příjem v důchodu?",
					DecreasedPensionIncomeSub:
						"(Rozdíl mezi předpokládanou budoucí hodnotou příjmu a důchodu)",
				},
				Chart: {
					Title: "Budoucí hodnota důchodu a příjmu",
					TitleNoRent: "Budoucí hodnota příjmu",
					SeriesStatePension: "Starobní důchod",
					SeriesNetIncome: "Čistý příjem",
					TypeBar: "Sloupcový",
					TypeLine: "Spojnicový",
					TypeToggleAriaLabel: "Typ grafu",
					AriaLabel: "Graf budoucí hodnoty důchodu a čistého příjmu",
					YearLabel: "{{age}}. rok",
					CurrentIncomeLabel: "Aktuální příjem",
				},
				Client: {
					ContextLabel: "Snížení příjmu v důchodu",
					Pointe:
						"Vstupem do důchodu Vám klesne měsíční příjem. Tento rozdíl je potřeba pokrýt vlastními úsporami.",
				},
			},
			RentTargetSum: {
				Title: "Potřebná částka",
				Subtitle:
					"Kolik peněz musíte mít v důchodu naspořeno, aby pokryly chybějící příjem po zvolenou dobu čerpání (nebo nekonečně).",
				ShortDescription: "Jakou částku potřebuji na pokrytí příjmu v důchodu?",
				Category: "Důchod",
				Inputs: {
					RequiredMonthlySum: "Potř. částka měsíčně (budoucí)",
					Period: "Doba čerpání",
					InfinityMode: "Nekonečné čerpání",
					MoneyAppreciation: "Zhodnocení peněz",
					Inflation: "Inflace",
					RetirementAge: "Věk odchodu do důchodu",
				},
				Metrics: {
					RequiredSum: "Potřebná částka",
					TitleFinite:
						"Jakou částku potřebuji pro zajištění příjmu po dobu {{period}}.",
					TitleInfinite:
						"Jakou částku potřebuji pro zajištění příjmu po nekonečnou dobu.",
					SubtitleFinite:
						"Při věku odchodu do důchodu ve věku {{retirementAge}} let je počítáno s čerpáním do věku {{endAge}} let.",
				},
				Chart: {
					Title: "Kolik peněz potřebuji na důchod?",
					SeriesRequiredSum: "Potřebná částka",
					TypeBar: "Sloupcový",
					TypeLine: "Spojnicový",
					TypeToggleAriaLabel: "Typ grafu",
					AriaLabel: "Graf potřebné částky na důchod",
					AxisLabel: "{{age}} let",
					InfinityLabel: "∞",
					MarkerAge65: "do 65 let",
					MarkerAge75: "do 75 let",
					MarkerAge85: "do 85 let",
					MarkerInfinite: "nekonečně",
					// "\n" wraps the pill onto two lines so the right-edge marker
					// doesn't get horizontally clipped at the chart container edge.
					MarkerDrawdownFinite: "Čerpání\n{{period}}",
					// MyDock literal — typo "čerpání" zachován verbatim z `Nekonečné čerpání`
					MarkerDrawdownInfinite: "Nekonečné\nčerpání",
				},
				Client: {
					ContextLabel: "Potřebná částka na důchod",
					Pointe:
						"Tato částka musí být naspořena do důchodu, aby pokryla chybějící příjem po zvolenou dobu čerpání.",
				},
			},
			RentInvestmentAmount: {
				Title: "Kolik investovat",
				Subtitle:
					"Potřebná měsíční investice, aby se cílová částka stihla nainvestovat do věku odchodu do důchodu.",
				ShortDescription: "Jakou částku musím měsíčně investovat?",
				Category: "Důchod",
				Inputs: {
					RequiredSum: "Potřebná částka",
					InvestmentStartYear: "Věk počátku investice",
					MoneyAppreciation: "Zhodnocení peněz",
					RetirementAge: "Věk odchodu do důchodu",
				},
				Metrics: {
					RequiredMonthlyInvestment: "Jakou částku musím měsíčně investovat?",
				},
				Chart: {
					SeriesRequiredMonthlyInvestment: "Potřebná částka",
					TypeBar: "Sloupcový",
					TypeLine: "Spojnicový",
					TypeToggleAriaLabel: "Typ grafu",
					AriaLabel: "Graf potřebné měsíční investice podle věku startu",
					AxisLabel: "{{age}} let",
					MarkerStepLabel: "od {{age}} let",
				},
				Client: {
					ContextLabel: "Potřebná měsíční investice",
					Pointe:
						"Začnete-li dříve, splátka je nižší — pozdější start znamená vyšší měsíční částku pro dosažení stejné cílové sumy.",
				},
			},
			RentInvestmentPostpone: {
				Title: "Odklad investice",
				Subtitle:
					"Porovnání měsíční investice „začnu hned“ vs. „začnu za X let“ pro stejnou cílovou částku.",
				ShortDescription:
					"O kolik větší investici budu potřebovat, když začnu později?",
				Category: "Důchod",
				Inputs: {
					RequiredSum: "Potřebná částka",
					InvestmentStartYear: "Věk počátku investice",
					MoneyAppreciation: "Zhodnocení peněz",
					RetirementAge: "Věk odchodu do důchodu",
					PostponeYears: "začnu za",
				},
				Metrics: {
					ImmediatePrefix: "začnu hned",
					PostponePrefix: "začnu za",
				},
				Chart: {
					AriaLabel: "Porovnání investice začnu hned vs. odklad",
					SeriesValue: "Potřebná částka",
				},
				Client: {
					ContextLabel: "Vliv odkladu investice",
					Pointe:
						"Každý rok odkladu zvyšuje měsíční investici nutnou pro dosažení stejné cílové částky.",
				},
			},
			RentRentOverview: {
				Title: "Kompletní modelace",
				Subtitle:
					"Kompletní pension model — odhad důchodu, chybějící příjem, jednorázová a pravidelná investice + zůstatek úspor v čerpání.",
				ShortDescription: "Kompletní modelace důchodu a úspor.",
				Category: "Důchod",
				Sections: {
					IncomeAndTax: "Příjmy a daňový základ",
					Pension: "Důchod",
					Investments: "Investice a délka čerpání",
					Appreciation: "Zhodnocení",
				},
				Inputs: {
					NetIncome: "Čistý měsíční příjem",
					GrossIncome: "Hrubý měsíční příjem",
					TaxBaseMode: "Způsob výpočtu vyměřovacího základu",
					AverageAnnualTaxBase: "Prům. roční základ daně OSVČ",
					Inflation: "Inflace",
					MonthlyInvestment: "Výše měsíční investice",
					OnetimeInvestment: "Výše jednorázové investice",
					ClientAge: "Věk klienta",
					RetirementAge: "Odchod do důchodu",
					IncludedYears: "Započtená doba pojištění",
					RentFinalAge: "Čerpání do věku",
					InfinityMode: "Nekonečné čerpání",
					MoneyAppreciation: "Zhodnocení investice",
					RentAppreciation: "Zhodnocení při čerpání",
					CustomPensionEnabled: "Vlastní výše důchodu",
					CustomPensionEnabledTooltip:
						"Vypočítaný důchod můžete nahradit zadanou částkou. Výpočet důchodu neproběhne a bude se pracovat pouze se zde zadanou částkou.",
					CustomPensionValue: "Vlastní částka důchodu",
				},
				Metrics: {
					TopResult: "O kolik se sníží můj příjem v důchodu?",
					BottomResult: "Potřebná částka celkem",
					TopResultSubtitle:
						"Při věku odchodu do důchodu ve věku {{retirementAge}} let",
					BottomResultSubtitle:
						"Čisté zhodnocení v průběhu čerpání {{percent}}",
				},
				TopChart: {
					Title: "Budoucí příjem a chybějící částka",
					SeriesPension: "Výše důchodu",
					SeriesMissing: "Chybějící částka",
					TypeBar: "Sloupcový",
					TypeLine: "Spojnicový",
					TypeToggleAriaLabel: "Typ grafu",
					AriaLabel: "Graf budoucí výše důchodu a chybějícího příjmu",
					AxisLabel: "{{age}} let",
				},
				BottomChart: {
					Title: "Akumulace a čerpání úspor",
					SeriesOnetimeInvestment: "Jednorázová investice",
					SeriesMonthlyInvestment: "Pravidelná investice",
					SeriesSavings: "Zůstatek úspor",
					TypeBar: "Sloupcový",
					TypeLine: "Spojnicový",
					TypeToggleAriaLabel: "Typ grafu",
					AriaLabel: "Graf akumulace investic a zůstatku úspor",
					AxisLabel: "{{age}} let",
				},
				Client: {
					ContextLabel: "Celkový pension výhled",
					Pointe:
						"Tato kompletní modelace ukazuje akumulaci investic a následné čerpání úspor v důchodu.",
				},
			},
			UnderinsurancePricesComparison: {
				Title: "Srovnání cen",
				Subtitle:
					"Jak se posunula hodnota nemovitosti od jejího pořízení podle vývoje cen v ČR.",
				ShortDescription:
					"Porovnání pořizovací ceny a současné hodnoty s grafem vývoje cen nemovitostí.",
				Category: "Podpojištění",
				Inputs: {
					YearOfAcquisition: "Rok pořízení",
					PurchasePrice: "Pořizovací cena",
					PresentValue: "Současná hodnota",
				},
				Visual: {
					LeftTitle: "pojistné krytí v době sjednání pojištění",
					RightTitle: "pojistné krytí nyní",
				},
				Chart: {
					Title: "Vývoj cen nemovitostí v ČR",
					SeriesJistina: "Jistina",
					TooltipRowName: "Vývoj ceny nemovitosti v ČR:",
					AriaLabel: "Graf vývoje cen nemovitostí v ČR",
					TypeBar: "Sloupcový",
					TypeLine: "Spojnicový",
					TypeToggleAriaLabel: "Typ grafu",
				},
				Notice:
					"Odhad ceny je založen na průměrném vývoji cen nemovitostí v ČR, může se tedy od reálné ceny konkrétní nemovitosti výrazně lišit.",
				Client: {
					ContextLabel: "Jak se posunula hodnota nemovitosti?",
					Pointe:
						"Graf ukazuje, jak se průměrná cena nemovitostí v ČR vyvíjela od roku pořízení.",
				},
			},
			GoalsFinancingBankLoan: {
				Title: "Úvěr",
				Subtitle:
					"Dvě varianty výpočtu — z požadované výše úvěru spočte měsíční splátku, nebo z měsíční splátky spočte maximální výši úvěru.",
				ShortDescription:
					"Splátka úvěru z požadované částky, nebo maximální výše úvěru z maximální splátky.",
				Category: "Financování cílů",
				Tabs: {
					AriaLabel: "Varianty výpočtu",
					Tab0Label: "Splátka úvěru",
					Tab1Label: "Maximální výše úvěru",
				},
				Inputs: {
					Tab0: {
						BankLoanNeeded: "Potřebná výše úvěru",
						BankLoanNeededDueDate: "Doba splatnosti",
						BankLoanNeededInterestRate: "Úroková sazba p.a.",
					},
					Tab1: {
						MaximumPayment: "Maximální splátka úvěru",
						MaximumPaymentDueDate: "Doba splatnosti",
						MaximumPaymentInterestRate: "Úroková sazba p.a.",
					},
				},
				Metrics: {
					Tab0: { ComputedPayment: "Splátka úvěru" },
					Tab1: { MaximumPaymentMaxBankLoan: "Maximální výše úvěru" },
				},
				Chart: {
					Tab0: {
						Title: "Vývoj splátky podle doby splatnosti",
						SeriesPayment: "Výše splátky úvěru",
					},
					Tab1: {
						Title: "Vývoj maximální výše úvěru podle doby splatnosti",
						SeriesMaxLoan: "Maximální výše úvěru",
					},
					TypeBar: "Sloupcový",
					TypeLine: "Spojnicový",
					TypeToggleAriaLabel: "Typ grafu",
					YearLabel: "{{year}}. rok",
					AriaLabel: "Graf úvěru v čase",
				},
				Client: {
					ContextLabel: "Úvěr v kostce",
					Pointe:
						"Tato kalkulačka spočte vhodnou splátku, nebo prostor pro úvěr v rámci vaší splátky.",
				},
			},
			GoalsFinancingInvestmentSingle: {
				Title: "Jednorázová investice",
				Subtitle:
					"Dvě varianty výpočtu — očekávaná hodnota jednorázové investice, nebo potřebná počáteční investice pro cílovou částku.",
				ShortDescription:
					"Budoucí hodnota jednorázové investice, nebo potřebná investice pro cílovou částku.",
				Category: "Financování cílů",
				Tabs: {
					AriaLabel: "Varianty výpočtu",
					Tab0Label: "Očekávaná hodnota",
					Tab1Label: "Potřebná investice",
				},
				Inputs: {
					Tab0: {
						OneTimeInvestment: "Jednorázová investice",
						OneTimeInvestmentPeriod: "Doba investování",
						OneTimeInvestmentExpectedYield: "Očekávaný výnos p.a.",
					},
					Tab1: {
						RequiredValue: "Požadovaná hodnota na konci",
						RequiredValueInvestmentPeriod: "Doba investování",
						RequiredValueExpectedYield: "Očekávaný výnos p.a.",
					},
				},
				Metrics: {
					Tab0: { ValueAfterPeriod: "Očekávaná hodnota na konci" },
					Tab1: { RequiredInitial: "Potřebná jednorázová investice" },
				},
				Chart: {
					Tab0: {
						Title: "Vývoj investice v čase",
						SeriesEvolution: "Vývoj v čase",
					},
					Tab1: {
						Title: "Potřebná investice v čase",
						SeriesRequired: "Potřebná investice",
					},
					TypeBar: "Sloupcový",
					TypeLine: "Spojnicový",
					TypeToggleAriaLabel: "Typ grafu",
					YearLabel: "{{year}}. rok",
					InvestmentStart: "Start investice",
					AriaLabel: "Graf jednorázové investice v čase",
				},
				Client: {
					ContextLabel: "Vaše jednorázová investice",
					Pointe:
						"Tato kalkulačka ukazuje budoucí hodnotu vaší jednorázové investice, případně kolik je třeba investovat pro cíl.",
				},
			},
			GoalsFinancingInvestmentRegular: {
				Title: "Pravidelná investice",
				Subtitle:
					"Tři varianty výpočtu — očekávaná budoucí hodnota, potřebná měsíční částka, nebo potřebná doba investice.",
				ShortDescription:
					"Budoucí hodnota pravidelné investice, potřebná měsíční částka, nebo potřebná doba.",
				Category: "Financování cílů",
				Tabs: {
					AriaLabel: "Varianty výpočtu",
					Tab0Label: "Očekávaná hodnota",
					Tab1Label: "Potřebná investice",
					Tab2Label: "Potřebná doba investice",
				},
				Inputs: {
					Tab0: {
						RegularInvestment: "Pravidelná investice (měsíčně)",
						RegularInvestmentPeriod: "Doba investování",
						RegularInvestmentExpectedYield: "Očekávaný výnos p.a.",
					},
					Tab1: {
						RequiredValue: "Požadovaná hodnota na konci",
						RequiredValueInvestmentPeriod: "Doba investování",
						RequiredValueExpectedYield: "Očekávaný výnos p.a.",
					},
					Tab2: {
						RequiredValueForCountPeriod: "Požadovaná hodnota na konci",
						RegularInvestmentForCountPeriod: "Pravidelná investice (měsíčně)",
						CountPeriodExpectedYield: "Očekávaný výnos p.a.",
					},
				},
				Metrics: {
					Tab0: {
						ValueAfterPeriod: "Očekávaná hodnota na konci",
						PaidOverall: "Zaplaceno celkem",
					},
					Tab1: { RequiredMonthly: "Potřebná pravidelná investice" },
					Tab2: { RequiredPeriod: "Potřebná doba investice" },
				},
				Chart: {
					Tab0: {
						Title: "Vývoj investice v čase",
						SeriesEvolution: "Vývoj v čase",
					},
					Tab1: {
						Title: "Potřebná investice v čase",
						SeriesRequired: "Potřebná investice",
					},
					Tab2: {
						Title: "Vývoj investice v čase",
						SeriesEvolution: "Vývoj v čase",
					},
					TypeBar: "Sloupcový",
					TypeLine: "Spojnicový",
					TypeToggleAriaLabel: "Typ grafu",
					YearLabel: "{{year}}. rok",
					InvestmentStart: "Start investice:",
					AriaLabel: "Graf pravidelné investice v čase",
				},
				Client: {
					ContextLabel: "Vaše pravidelná investice",
					Pointe:
						"Pravidelným investováním si vytváříte cestu k dlouhodobému cíli — tato kalkulačka spočítá výsledek, potřebný vklad nebo dobu.",
				},
			},
			GoalsFinancingRent: {
				Title: "Renta",
				Subtitle:
					"Dvě varianty výpočtu — měsíční renta z naspořené částky, nebo potřebná výše úspor pro cílovou rentu. S možností nekonečného čerpání.",
				ShortDescription:
					"Měsíční renta z naspořené částky, nebo potřebná částka pro cílovou rentu.",
				Category: "Financování cílů",
				Tabs: {
					AriaLabel: "Varianty výpočtu",
					Tab0Label: "Měsíční renta",
					Tab1Label: "Potřebná výše úspor",
				},
				Inputs: {
					Tab0: {
						SavedAmount: "Naspořená částka",
						SavedAmountDrawTime: "Doba čerpání",
						IsInfinityMode: "Donekonečna",
						SavedAmountExpectedYield: "Očekávaný výnos p.a.",
					},
					Tab1: {
						RequiredMonthlyRent: "Požadovaná měsíční renta",
						RequiredMonthlyRentDrawTime: "Doba čerpání",
						IsInfinityMode: "Donekonečna",
						RequiredMonthlyRentExpectedYield: "Očekávaný výnos p.a.",
					},
				},
				Metrics: {
					Tab0: { MonthlyRent: "Měsíční renta" },
					Tab1: { RequiredSaved: "Potřebná výše úspor" },
				},
				Chart: {
					Tab0: {
						Title: "Vývoj měsíční renty podle doby čerpání",
						SeriesMonthlyRent: "Výše měsíční renty",
					},
					Tab1: {
						Title: "Potřebná výše úspor podle doby čerpání",
						SeriesRequired: "Potřebná výše úspor",
					},
					TypeBar: "Sloupcový",
					TypeLine: "Spojnicový",
					TypeToggleAriaLabel: "Typ grafu",
					YearLabel: "{{year}}. rok",
					AriaLabel: "Graf renty v čase",
				},
				Client: {
					ContextLabel: "Vaše renta",
					Pointe:
						"Tato kalkulačka ukazuje výši renty z vašich úspor, případně kolik je třeba naspořit pro cílovou rentu.",
				},
			},
			GoalsFinancingInvestmentByProducts: {
				Title: "Investice podle produktů",
				Subtitle:
					"Porovnejte vývoj investic v různých produktech (bankovní účet, stavební spoření, DPS, zlato, podílové fondy, nemovitosti) nebo si zobrazte celkové portfolio v čase.",
				ShortDescription:
					"Porovnání vývoje investic v různých produktech, nebo souhrnný pohled na portfolio.",
				Category: "Financování cílů",
				AddProduct: "Přidat produkt",
				ListTitle: "Finanční produkty",
				Empty:
					"Zatím nemáte přidané žádné produkty. Klikněte na „Přidat produkt“.",
				Sections: {
					Products: "Produkty",
				},
				Row: {
					OneTimeSummary: "{{amount}} jednorázově",
					MonthlySummary: "{{amount}} měs.",
					YearsSummary: "{{years}} let",
					InfoAriaLabel: "Detail produktu",
					EditAriaLabel: "Upravit produkt",
					DeleteAriaLabel: "Odebrat produkt",
					ProductRowLabel: "{{index}}. produkt",
				},
				ProductTypes: {
					BankAccount: "Bankovní účty",
					BuildingSavings: "Stavební spoření",
					Dps: "Doplňkové penzijní spoření",
					Gold: "Zlato",
					MutualFunds: "Podílové fondy",
					RealEstate: "Nemovitosti",
				},
				Inputs: {
					ProductType: "Typ produktu",
					OneTimeInvestment: "Jednorázový vklad",
					MonthlyInvestment: "Měsíční vklad",
					MonthlyEmployeeInvestment: "Měsíční příspěvek účastníka",
					MonthlyEmployerInvestment: "Příspěvek zaměstnavatele",
					InvestmentPeriod: "Doba spoření",
					ExpectedYield: "Zhodnocení p.a.",
					EntryFee: "Vstupní poplatek",
					DeferInvestment: "Odložit investici",
				},
				Tooltip: {
					OneTimeInvestment: "Jednorázový vklad:",
					MonthlyInvestment: "Měsíční vklad:",
					MonthlyEmployeeInvestment: "Příspěvek účastníka:",
					MonthlyEmployerInvestment: "Příspěvek zaměstnavatele:",
					InvestmentPeriod: "Doba spoření:",
					DeferInvestment: "Odklad investice:",
					ExpectedYield: "Zhodnoceni p.a.:",
					IncomeTax: "Zdanění výnosu:",
					AccountFee: "Poplatek z CČ:",
					AnnualFee: "Poplatek roční:",
					Spread: "Spread:",
					EntryFee: "Vstupní poplatek:",
					FlatCosts: "Paušální náklady:",
				},
				AddDialog: {
					Title: "Finanční produkty",
					PickTypeStep: "Vyberte typ produktu",
					ConfigureStep: "Nastavení produktu",
					Back: "Zpět na výběr",
					Submit: "Přidat produkt",
				},
				EditDialog: {
					Title: "Úprava vybraného produktu",
					Submit: "Upravit produkt",
				},
				DeleteDialog: {
					Title: "Odebrat produkt",
					Body: "Opravdu si přejete odebrat produkt „{{name}}“?",
					Confirm: "Potvrdit",
					Cancel: "Zrušit",
				},
				Chart: {
					Title: "Vývoj investic v čase",
					TypeToggleAriaLabel: "Pohled na graf",
					TypeComparison: "porovnání",
					TypePortfolio: "portfolio",
					PortfolioSeriesName: "Vývoj hodnoty portfolia v čase",
					TooltipStart: "Start investice",
					TooltipMonthly: "Měsíc {{month}}. Rok {{year}}",
					TooltipQuarterly: "Q{{quarter}}. Rok {{year}}",
					TooltipBiannually: "Pololetí {{half}}. Rok {{year}}",
					TooltipAnnually: "Rok {{year}}",
					AriaLabel: "Graf vývoje investic v čase",
				},
				Client: {
					ContextLabel: "Vaše investice",
					Pointe:
						"Tato kalkulačka ukazuje vývoj jednotlivých finančních produktů a celého portfolia v čase.",
				},
			},
			IncomeProtectionRiskOverview: {
				Title: "Přehled rizik",
				Subtitle: "Co všechno se mi může stát — strom rizik výpadku příjmu.",
				ShortDescription:
					"Edukační schéma rizik výpadku příjmu od krátkodobé nemoci po trvalé následky.",
				Category: "Zabezpečení příjmů",
				Intro: {
					EduTag: "Edukační modul · žádné výpočty",
					Heading: "Co všechno se mi může stát?",
					Body: "Než se podíváme na čísla, projděme si, jak může vypadat výpadek příjmu domácnosti. Začneme od krátkodobé nemoci a postupně se dostaneme až k trvalým následkům.",
				},
				Stages: {
					SicknessTitle: "Nemoc / Úraz",
					SicknessSubtitle:
						"Spouštěč — jakákoli zdravotní událost, která brání práci",
					KpnTitle: "Krátkodobá pracovní neschopnost",
					KpnSubtitle:
						"Prvních 14 dní hradí zaměstnavatel (60 % mzdy), poté nemocenské dávky ČSSZ",
					KpnIncome: "Náhrada mzdy + nemocenské dávky · obvykle 60–70 % příjmu",
					KpnDetailHint: "MOD-6-3 KPN denní ztráta",
					AfterOneYear: "po 1 roce nemoci",
					PermanentTitle: "Trvalý výpadek příjmu",
					PermanentSubtitle:
						"Stav se nelepší → ČSSZ posuzuje invaliditu nebo (v nejhorším) úmrtí",
				},
				Branches: {
					Inv1Title: "Invalidita 1. stupně",
					Inv1Subtitle: "Pokles pracovní schopnosti 35–49 %",
					Inv1Income: "Částečný invalidní důchod od ČSSZ",
					Inv2Title: "Invalidita 2. stupně",
					Inv2Subtitle: "Pokles pracovní schopnosti 50–69 %",
					Inv2Income: "Střední invalidní důchod",
					Inv3Title: "Invalidita 3. stupně",
					Inv3Subtitle: "Pokles pracovní schopnosti ≥ 70 %",
					Inv3Income: "Plný invalidní důchod, nelze pracovat",
					DeathTitle: "Úmrtí",
					DeathSubtitle: "Trvalá ztráta rodičovského příjmu",
					DeathIncome: "Vdovský/vdovecký + sirotčí důchod",
				},
				Survivors: {
					Label: "Pozůstalostní dávky",
					Widow: "Vdovský / vdovecký důchod (ČSSZ)",
					Orphan: "Sirotčí důchod pro nezletilé děti",
					Funeral: "Pohřebné, jednorázové dávky",
				},
				IncomeForFamily: "Příjem rodiny: ",
				DetailModule: "Detail modulu",
				Recap: {
					Heading: "Co to znamená pro vaši rodinu",
					Item1Strong: "Krátkodobý výpadek (do 1 roku)",
					Item1: " řeší stát i zaměstnavatel — ztráta 30–40 % příjmu.",
					Item2Strong: "Invalidita 1. a 2. stupně",
					Item2: " — důchod od ČSSZ pokrývá jen základ, hlavní příjem chybí.",
					Item3Strong: "Invalidita 3. stupně",
					Item3:
						" — nelze pracovat, plný důchod nestačí na běžné výdaje rodiny.",
					Item4Strong: "Úmrtí",
					Item4:
						" — sirotčí a vdovský důchod nepokrývá hypotéku, životní úroveň výrazně klesá.",
				},
				Compliance: {
					Heading: "Zdroj definic & compliance",
					Body: "Schéma vychází z platné legislativy: Zákon č. 187/2006 Sb. (nemocenské pojištění), Zákon č. 155/1995 Sb. (důchodové pojištění). Definice stupňů invalidity dle ČSSZ. Aktualizováno k 1. 1. 2026.",
					AdvisorNote:
						"Compliance: tento modul je edukační, neobsahuje konkrétní doporučení produktu. Pro klientský výstup zkombinujte s MOD-6-9 (Potřebné zabezpečení) a MOD-6-10 (Současné zabezpečení).",
				},
				QuickLinks: {
					Heading: "Rychlé prokliky na detailní moduly",
					Kpn: "KPN — denní ztráta",
					KpnReserve: "KPN — finanční rezerva",
					Inv1: "Invalidita 1. stupně",
					Inv2: "Invalidita 2. stupně",
					Inv3: "Invalidita 3. stupně",
					Death: "Úmrtí",
				},
			},
			IncomeProtectionCurrentSecurity: {
				Title: "Současné zabezpečení",
				Subtitle: "Co všechno mám sjednáno a jak velkou část rizik to pokryje.",
				ShortDescription:
					"% krytí každého rizika z existujících smluv + krytí majetkem.",
				Category: "Zabezpečení příjmů",
				PartnerToggle: {
					Label: "Partner",
					Hint: "Pokud chcete modelovat zabezpečení i pro partnera, zapněte přepínač — sdílí se napříč všemi obrazovkami této sekce.",
					Toggle: "Modelovat partnera",
				},
				Tabs: {
					Client: "Klient",
					Partner: "Partner",
					AriaLabel: "Přepínač osoby",
				},
				Inputs: {
					ReserveSection: "Finanční rezerva",
					ReserveRequired: "Potřeba",
					ReserveCurrent: "Současná rezerva",
					KpnSection: "KPN — denní krytí",
					KpnRequired: "Potřeba / den",
					KpnCurrent: "Pojištění denní dávky",
					InvSection: "Invalidita (souhrn)",
					InvRequired: "Potřeba",
					InvCurrent: "Pojistné krytí",
					InvFromAssets: "Krytí majetkem",
					DeathSection: "Úmrtí",
					DeathRequired: "Potřeba",
					DeathCurrent: "Pojistné krytí",
					PcSection: "Trvalé následky úrazu",
					PcRequired: "Potřeba",
					PcCurrent: "Pojistné krytí",
					PcFromAssets: "Krytí majetkem",
					SdSection: "Vážná onemocnění",
					SdRequired: "Potřeba",
					SdCurrent: "Pojistné krytí",
					SdFromAssets: "Krytí majetkem",
				},
				AdditionalRisksToggle: {
					Label: "Další rizika",
					Hint: "Trvalé následky úrazu a vážná onemocnění — ne každý je má v hlavním plánu, zobrazte je jen pokud je modelujete.",
					Toggle: "Zobrazit další rizika",
				},
				Risks: {
					FinancialReserve: "Finanční rezerva",
					DailyLossOfIncome: "KPN — denní krytí",
					InvaliditySummary: "Invalidity (souhrn)",
					Death: "Úmrtí",
					PermanentConsequences: "Trvalé následky úrazu",
					SeriousDiseases: "Vážná onemocnění",
				},
				Metrics: {
					TotalRequired: "Celková potřeba",
					TotalRequiredHint: "součet ze všech rizik",
					TotalCovered: "Celkové krytí",
					TotalCoveredHint: "pojistka + majetek",
					OverallPct: "Pokrytí celkem",
					OverallPctHint: "vážený průměr",
				},
				Coverage: {
					Required: "Potřeba",
					Insurance: "Pojistka",
					Assets: "Majetek",
				},
				Client: {
					ClientHeading: "Klient",
					PartnerHeading: "Partner",
					InsightContext: "Vaše současné krytí pokrývá",
					InsightPointe:
						"Z {{required}} potřebných máte zajištěno {{covered}}.",
					InsightFollowup:
						"Nejkritičtější díry typicky najdete u KPN, finanční rezervy a úmrtí — viz porovnání před/po na další obrazovce.",
				},
			},
			IncomeProtectionSecurityComparison: {
				Title: "Porovnání zabezpečení",
				Subtitle:
					"Před a po doporučení — kolik krytí přibude u každého rizika.",
				ShortDescription:
					"Side-by-side současné vs. navrhované krytí pro 4 rizika.",
				Category: "Zabezpečení příjmů",
				Units: {
					CzkPerDay: "Kč/den",
				},
				PartnerToggle: {
					Label: "Partner",
					Hint: "Pokud chcete porovnání i pro partnera, zapněte přepínač — sdílí se napříč všemi obrazovkami této sekce.",
					Toggle: "Modelovat partnera",
				},
				AdditionalRisksToggle: {
					Label: "Další rizika",
					Hint: "Trvalé následky úrazu a vážná onemocnění — ne každý je má v hlavním plánu, zobrazte je jen pokud je modelujete.",
					Toggle: "Zobrazit další rizika",
				},
				Tabs: {
					Client: "Klient",
					Partner: "Partner",
					AriaLabel: "Přepínač osoby",
				},
				Inputs: {
					EditCardTitle: "Editace krytí pro každé riziko",
					DetailCardTitle: "Detail rizik",
					Required: "Potřeba",
					Current: "Současné krytí",
					Proposed: "Navrhované krytí",
				},
				Risks: {
					FinancialReserve: "Finanční rezerva",
					DailyLossOfIncome: "KPN — denní krytí",
					InvaliditySummary: "Invalidity (souhrn)",
					Death: "Úmrtí",
					PermanentConsequences: "Trvalé následky úrazu",
					SeriousDiseases: "Vážná onemocnění",
				},
				Columns: {
					CurrentLabel: "Dnes",
					ProposedLabel: "Po doporučení",
					AmountOf: "{{amount}} z {{required}}",
				},
				Metrics: {
					Before: "Před doporučením",
					BeforeHint: "vážený průměr krytí",
					After: "Po doporučení",
					AfterHint: "vážený průměr krytí",
					Delta: "Nárůst krytí",
					DeltaHint: "díky novým produktům",
				},
				Client: {
					ClientHeading: "Klient",
					PartnerHeading: "Partner",
					InsightContext: "Vaše krytí se po přijetí doporučení zvedne z",
					InsightPointe:
						"Doporučení uzavírá hlavní díry — všechna kritická rizika budou pokryta.",
					InsightFollowup:
						"Pro každé riziko porovnejte sloupec před a po. Zelená = pokryto, červená = chybí.",
				},
			},
			IncomeProtectionCausesOfDisability: {
				Title: "Příčiny rizik",
				Subtitle:
					"Statistický pohled na nejčastější příčiny invalidity a úmrtí v ČR.",
				ShortDescription:
					"Edukační modul s donut grafy příčin invalidity (VÚBP) a úmrtí (ČSÚ).",
				Category: "Zabezpečení příjmů",
				Datasets: {
					InvalidityTitle: "Invalidita podle příčiny",
					InvaliditySub: "Hlavní příčiny přiznané invalidity",
					InvaliditySource: "VÚBP — Výzkumný ústav bezpečnosti práce",
					InvaliditySourcePeriod: "Data za rok 2022 (zveřejněno 2023)",
					InvalidityTopHighlight: "{{value}} % invalidit má původ v nemocech",
					DeathTitle: "Úmrtí podle příčiny",
					DeathSub: "Skladba úmrtí v ČR",
					DeathSource: "ČSÚ — Český statistický úřad",
					DeathSourcePeriod: "Data za rok 2023 (zveřejněno 2024)",
					DeathTopHighlight: "{{value}} % úmrtí má příčinu v nemoci",
				},
				Client: {
					InsightContext:
						"Z dat ČSÚ a VÚBP — nejčastější příčinou invalidity i úmrtí jsou",
					InsightPrimary: "nemoci",
					InsightPointe:
						"Nikoliv úrazy. Úrazy a poranění tvoří jen 3 % invalidit a 4 % úmrtí — drtivá většina rizik plyne z dlouhodobých zdravotních problémů.",
					InsightFollowup:
						"To je důvod, proč klasické úrazové pojištění samo nestačí. Pojistka musí krýt i nemoci, dlouhodobou pracovní neschopnost a invaliditu.",
					TakeawayStrong: "Co z toho plyne?",
					TakeawayBody:
						"Pokud má pojistka krýt skutečná rizika, musí pokrývat především",
					TakeawayHighlight:
						"nemoci a dlouhodobou neschopnost — ne jen úrazy. Mladí a zdraví klienti často podceňují civilizační choroby (svalově-kostní, duševní, kardiovaskulární), přitom právě tyto vedou k invaliditě nejčastěji.",
				},
				Advisor: {
					ChooseDataset: "Statistické datasety",
					ChooseDatasetHint:
						"Tento modul je čistě edukační — pracuje se statistickými daty, neaplikuje na konkrétního klienta. Vyberte dataset, který chcete prezentovat.",
					TableCause: "Příčina",
					TableShare: "Podíl",
					InvaliditySourceLabel: "Invalidita — zdroj",
					DeathSourceLabel: "Úmrtí — zdroj",
					InvaliditySourceSub:
						"Výzkumný ústav bezpečnosti práce — statistika přiznaných invalidních důchodů podle hlavní diagnózy",
					DeathSourceSub:
						"Český statistický úřad — Demografická ročenka, kapitola Zemřelí podle příčin smrti",
					OpenSource: "Otevřít zdroj",
					Compliance: "Compliance:",
					ComplianceBody:
						"Data jsou statistická a populační, neodrážejí konkrétního klienta. Pravděpodobnost rizika u jednotlivce závisí na věku, pohlaví, profesi, zdravotním stavu a životním stylu — pro personalizaci použijte modul „Přehled rizik“.",
					UpdateNote:
						"Datasety se aktualizují ručně 1× ročně po zveřejnění nových dat ČSÚ a VÚBP.",
				},
				PieAriaInvalidity: "Donut graf příčin invalidity podle VÚBP 2022",
				PieAriaDeath: "Donut graf příčin úmrtí podle ČSÚ 2023",
				TopCauseLabel: "Hlavní příčina",
			},
			IncomeProtectionInvalidityShared: {
				PartnerToggle: {
					Label: "Přidat partnera",
					Toggle: "Přidat partnera",
				},
				Tabs: {
					Client: "Klient",
					Partner: "Partner",
					AriaLabel: "Klient nebo Partner",
				},
				Sections: {
					Inputs: "Vstupy modelace",
				},
				Inputs: {
					YAxisLabel: "Cílová úroveň zajištění",
					XAxisLabel: "Délka zajištění",
					CustomAmountLabel: "Vlastní částka",
					CustomPeriodLabel: "Doba zajištění",
					YearsSuffix: "let",
				},
				YAxis: {
					CustomAmount: "Vlastní částka",
					NetIncome: "Čistý příjem",
					TotalExpenses: "Celkové výdaje",
					MandatoryExpenses: "Nezbytné výdaje",
				},
				Metrics: {
					RevenueDropCover: "Zajištění propadu příjmů",
					RevenueDropCoverHint:
						"Jednorázová částka pro pokrytí ztráty po dobu zajištění.",
					NecessarySecurityTotal: "Potřebné zajištění celkem",
					NecessarySecurityTotalHint:
						"Součet položek potřebného zajištění + krytí propadu.",
				},
				Chart: {
					Title: "Vývoj příjmu v invaliditě",
					Placeholder: "Pro zobrazení grafu zadejte vstupy.",
					AriaLabel:
						"Vývoj příjmu domácnosti v invaliditě po dobu zajištění — invalidní důchod, zbylý příjem, potřebné zajištění a požadovaná částka.",
					SeriesFamilyIncome: "Zbylý příjem rodiny",
					SeriesRestIncome: "Zbylý příjem klienta",
					SeriesNecessarySecurity: "Potřebné zajištění",
					SeriesRequiredAmount: "Potřebná částka",
					RightAnnotationWithInflation: "s inflací:",
				},
				NecessarySecurityList: {
					Title: "Potřebné zajištění — položky",
					Empty: "Zatím žádné položky potřebného zajištění.",
					MoreItems: "+ {{count}} dalších položek",
				},
				ModalButtons: {
					Person: "Upravit údaje o osobách",
					Income: "Upravit příjmy",
					Expense: "Upravit výdaje",
					Option: "Nastavení",
					NecessarySecurity: "Upravit potřebné zajištění",
				},
				PersonModal: {
					Title: "Údaje o osobách",
					ClientSection: "Klient",
					PartnerSection: "Partner",
					ChildrenSection: "Děti",
					FirstName: "Jméno",
					LastName: "Příjmení",
					BirthDate: "Datum narození",
					IncludedYears: "Započtená doba pojištění",
					YearsSuffix: "let",
					AddChild: "Přidat dítě",
					RemoveChild: "Odebrat dítě",
					ChildName: "Jméno dítěte",
					ChildBirthDate: "Datum narození dítěte",
					ChildrenEmpty: "Zatím žádné děti.",
					Apply: "Upravit údaje",
				},
				IncomeModal: {
					TitleClient: "Příjmy klienta",
					TitlePartner: "Příjmy partnera",
					EmploymentType: "Typ zaměstnání",
					EmploymentEmployee: "Zaměstnání",
					EmploymentOsvc: "OSVČ",
					EmploymentBoth: "Obojí",
					NetIncome: "Čistý měsíční příjem",
					GrossIncome: "Hrubý měsíční příjem",
					AssessmentBase: "Způsob výpočtu vyměřovacího základu",
					AssessmentPlaceholder: "Vyberte typ vyměřovacího základu",
					AssessmentHint:
						"Výběrem se předvyplní roční vyměřovací základ; lze ručně přepsat.",
					AnnualTaxBase: "Roční vyměřovací základ OSVČ",
					PasiveIncomes: "Pasivní příjmy",
					PasiveIncomesHint:
						"Měsíční příjmy z nezávislých zdrojů (nájem, dividendy, autorská práva apod.), které trvají i během invalidity.",
					Apply: "Upravit příjmy",
				},
				ExpenseModal: {
					Title: "Výdaje",
					Hint: "Přidejte měsíční výdaje rozdělené na povinné a dobrovolné.",
					Empty: "Zatím žádné výdaje.",
					Add: "Přidat výdaj",
					Remove: "Odebrat výdaj",
					RowName: "Název",
					RowValue: "Částka",
					RowType: "Typ",
					RowMinimal: "Minimální nutná částka",
					TypeVoluntary: "Dobrovolný",
					TypeMandatory: "Povinný",
					Apply: "Upravit výdaje",
				},
				OptionModal: {
					Title: "Nastavení modelace",
					UseInflation: "Chci počítat s inflací",
					UseInflationTooltip:
						"Při výpočtu můžete zohlednit inflaci. V takovém případě budou všechny částky v čase valorizovány o hodnotu inflace. Potřebná výsledná částka tedy bude vyšší než bez započítání inflace.",
					InflationValue: "Roční inflace",
					UseEvaluation: "Chci počítat se zhodnocením",
					UseEvaluationTooltip:
						"Při výpočtu můžete počítat s tím, že získané prostředky budou v průběhu čerpání investovány. Očekávaný výnos tak pokryje část potřebných prostředků a potřebná částka tedy může být nižší než bez započítání zhodnocení.",
					EvaluationValue: "Roční zhodnocení",
					UseCustomParameters: "Upravit parametry výpočtu",
					UseCustomParametersTooltip:
						"Vypočítané částky zbylého příjmu a invalidního důchodu můžete nahradit vlastními hodnotami.",
					UseResidualIncome: "Vlastní hodnota zbylého příjmu",
					UseResidualIncomeTooltip:
						"Vypočítaný zbylý příjem můžete nahradit zadanou částkou. Výpočet zbylého příjmu neproběhne a bude se pracovat pouze se zde zadanou částkou.",
					ResidualIncomeValue: "Výše zbylého příjmu",
					UseSocialBenefit: "Vlastní hodnota sociální dávky",
					UseSocialBenefitTooltip:
						"Vypočítanou výši invalidního důchodu můžete nahradit zadanou částkou. Výpočet invalidního důchodu neproběhne a bude se pracovat pouze se zde zadanou částkou.",
					SocialBenefitValue: "Výše sociální dávky",
					InfoIconAriaLabel: "Vysvětlení",
					Apply: "Uložit nastavení",
				},
				NecessarySecurityModal: {
					Title: "Potřebné zajištění",
					Hint: "Přidejte položky potřebného zajištění (jednorázové i průběžné).",
					Empty: "Zatím žádné položky.",
					Add: "Přidat položku",
					Remove: "Odebrat položku",
					RowName: "Název",
					RowValue: "Částka",
					Apply: "Upravit potřebné zajištění",
				},
				Client: {
					ContextLabel: "Potřebné zajištění",
					Pointe: "Tolik si potřebujete zajistit pro pokrytí výpadku příjmu.",
					InputsTitle: "Vstupy modelace",
					InputsCustomAmount: "Vlastní částka",
					InputsCustomPeriod: "Doba zajištění",
					InputsNetIncome: "Čistý měsíční příjem",
					InputsGrossIncome: "Hrubý měsíční příjem",
					InputsYAxisLabel: "Cílová úroveň zajištění",
					InputsXAxisLabel: "Délka zajištění",
					NecessarySecurityTitle: "Potřebné zajištění — položky",
					NecessarySecurityEmpty: "Zatím žádné položky potřebného zajištění.",
				},
			},
			IncomeProtectionFirstInvalidity: {
				Title: "Invalidita 1. st.",
				Subtitle:
					"Co se stane, když budu lehce invalidní (1. stupeň)? Invalidní důchod + zbytkový čistý příjem ze sníženého úvazku.",
				ShortDescription:
					"Modelace měsíčního výpadku příjmu při invaliditě 1. stupně — kolik klientovi opravdu chybí vs. původní čistý příjem.",
				Category: "Zabezpečení příjmů",
				SeriesInvalidityLabel: "Invalidní důchod (1.st.)",
			},
			IncomeProtectionSecondInvalidity: {
				Title: "Invalidita 2. st.",
				Subtitle:
					"Co se stane, když budu středně invalidní (2. stupeň)? Invalidní důchod 2. st. + výrazně omezený zbytkový příjem (≈ 30 % původního čistého).",
				ShortDescription:
					"Modelace měsíčního výpadku příjmu při invaliditě 2. stupně — výrazně vyšší propad než u 1. stupně.",
				Category: "Zabezpečení příjmů",
				SeriesInvalidityLabel: "Invalidní důchod (2.st.)",
			},
			IncomeProtectionThirdInvalidity: {
				Title: "Invalidita 3. st.",
				Subtitle:
					"Co se stane, když budu plně invalidní (3. stupeň)? Klient nemůže pracovat — jen invalidní důchod 3. st.",
				ShortDescription:
					"Modelace měsíčního výpadku při plné invaliditě — žádný zbytkový příjem z práce, jediným zdrojem je invalidní důchod 3. st.",
				Category: "Zabezpečení příjmů",
				SeriesInvalidityLabel: "Invalidní důchod (3.st.)",
			},
			IncomeProtectionKPNShared: {
				PartnerToggle: {
					Label: "Přidat partnera",
					Toggle: "Přidat partnera",
				},
				Tabs: {
					Client: "Klient",
					Partner: "Partner",
					AriaLabel: "Klient nebo Partner",
				},
				Sections: {
					Inputs: "Vstupy modelace",
				},
				Inputs: {
					TargetLabel: "Cíl zajištění",
					CustomAmountLabel: "Vlastní částka",
				},
				Target: {
					Income: "Čistý příjem",
					Custom: "Vlastní částka",
				},
				ModalButtons: {
					Income: "Upravit příjmy",
				},
				IncomeModal: {
					TitleClient: "Příjmy klienta",
					TitlePartner: "Příjmy partnera",
					EmploymentType: "Typ zaměstnání",
					EmploymentEmployee: "Zaměstnání",
					EmploymentOsvc: "OSVČ",
					EmploymentBoth: "Obojí",
					NetIncome: "Čistý měsíční příjem",
					GrossIncome: "Hrubý měsíční příjem",
					HealthInsurance: "Měsíční platba nemocenského pojištění OSVČ",
					HealthInsuranceHint:
						"OSVČ platí dobrovolně. Bez něj nemáte nárok na nemocenské dávky.",
					Apply: "Upravit příjmy",
				},
				Chart: {
					Title: "Měsíční náhrada vs požadovaný příjem",
					Placeholder: "Pro zobrazení grafu zadejte vstupy.",
					AriaLabel:
						"Graf 12 měsíců sociálních dávek a chybějící části vs požadovaný měsíční příjem.",
					MonthSuffix: "měsíc",
					// Verbatim z MyDocku ChartIncomeProtection{DailyLoss,FinancialReserve}Component series.name.
					SeriesBenefit: "Sociální dávky",
					SeriesGap: "Potřebné zajištění",
				},
				Client: {
					ContextLabel: "Potřebná částka",
					InputsTitle: "Vstupy modelace",
					InputsTarget: "Cíl zajištění",
					InputsCustomAmount: "Vlastní částka",
					InputsNetIncome: "Čistý měsíční příjem",
					InputsGrossIncome: "Hrubý měsíční příjem",
				},
			},
			IncomeProtectionDailyLossOfIncome: {
				Title: "KPN - denní ztráta",
				Subtitle:
					"Co dostanu z dávek pokud budu rok v pracovní neschopnosti? Náhrada mzdy + nemocenské vs požadovaný měsíční příjem.",
				ShortDescription:
					"Krátkodobá ztráta příjmu (PN) — 12 měsíční náhrada mzdy + nemocenské dávky, zbytek se musí pokrýt vlastními zdroji nebo pojistkou.",
				Category: "Zabezpečení příjmů",
				Metrics: {
					RequiredAmount: "Požadovaná částka (roční)",
					RequiredAmountHint:
						"12 × cílový měsíční příjem — celkem co potřebujete za rok.",
					SocialBenefits: "Sociální dávky",
					SocialBenefitsHint: "Celkem náhrada mzdy + nemocenské za rok.",
					NecessarySecurity: "Nezbytné zajištění",
					NecessarySecurityHint: "Kolik chybí dokrytí požadované roční částky.",
					RequiredDailyIncomeReplacement: "Potřebná denní náhrada příjmu",
					RequiredDailyIncomeReplacementHint:
						"Měsíčně chybí ÷ 30 dní — denní krytí, které je třeba sjednat.",
				},
			},
			IncomeProtectionFinancialReserve: {
				Title: "KPN - finanční rezerva",
				Subtitle:
					"Jak velkou rezervu si musím nashromáždit, abych přečkal 3/6/12 měsíců PN? Součet měsíčně chybějících prostředků.",
				ShortDescription:
					"Rezerva pro pokrytí krátkodobé pracovní neschopnosti — tři úrovně podle požadované doby.",
				Category: "Zabezpečení příjmů",
				Metrics: {
					FirstReserve: "Potřebná rezerva na 3 měsíce",
					FirstReserveHint:
						"Součet chybějících prostředků za první 3 měsíce PN.",
					SecondReserve: "Potřebná rezerva na 6 měsíců",
					SecondReserveHint:
						"Součet chybějících prostředků za prvních 6 měsíců PN.",
					ThirdReserve: "Potřebná rezerva na 12 měsíců",
					ThirdReserveHint: "Součet chybějících prostředků za celý rok PN.",
				},
			},
			IncomeProtectionSecurityRequired: {
				// MyDock název obrazovky: "Potřebné zabezpečení".
				Title: "Potřebné zabezpečení",
				Subtitle:
					"Souhrn — kolik potřebuješ zabezpečit pro každé riziko (1./2./3. invalidita, smrt, KPN denní ztráta, KPN finanční rezerva) a kolik už máš sjednáno.",
				ShortDescription:
					"Agregát — porovná vypočtené potřebné zabezpečení z 6 rizik vs aktuálně sjednané pojištění.",
				Category: "Zabezpečení příjmů",
				PartnerToggle: {
					Label: "Přidat partnera",
					Toggle: "Přidat partnera",
				},
				Tabs: {
					Client: "Klient",
					Partner: "Partner",
					AriaLabel: "Klient nebo Partner",
				},
				Sections: {
					Inputs: "Vstupy modelace",
					KpnSettings: "KPN — finanční rezerva",
				},
				Kpn: {
					NumOfMonthsLabel: "Počet měsíců krátkodobé pracovní neschopnosti",
					NumOfMonthsHint:
						"Kolik měsíců trvání PN bere v úvahu agregovaná suma „Finanční rezerva“ — sčítá chybějící prostředky za prvních N měsíců z modulu KPN - finanční rezerva.",
					MonthSuffixOne: "měsíc",
					MonthSuffixFew: "měsíce",
					MonthSuffixMany: "měsíců",
					FinReserveComputed: "Potřebná finanční rezerva",
					FinReserveComputedHint:
						"Součet chybějících prostředků za zvolený počet měsíců (z KPN - finanční rezerva).",
					DailyLossComputed: "Potřebná denní náhrada příjmu",
					DailyLossComputedHint: "Vychází z modulu KPN - denní ztráta.",
					DailyLossSuffix: "denně",
				},
				Metrics: {
					TotalRequired: "Celkem potřebné zajištění",
					TotalRequiredHint:
						"Součet potřebného zajištění napříč všemi 6 riziky.",
					TotalCurrent: "Celkem sjednané",
					TotalCurrentHint:
						"Součet aktuálně sjednaných pojistek (z modulu Současné zabezpečení).",
					Coverage: "Pokrytí",
					Covered: "Pokryto v plné výši.",
					GapPrefix: "Chybí",
				},
				Risks: {
					DailyLossOfIncome: "Denní ztráta příjmu (KPN)",
					FinancialReserve: "Finanční rezerva (KPN)",
					FirstInvalidity: "Invalidita 1. st.",
					SecondInvalidity: "Invalidita 2. st.",
					ThirdInvalidity: "Invalidita 3. st.",
					Death: "Smrt",
				},
				Table: {
					Title: "Porovnání rizik",
					EmptyUpstream:
						"Pro zobrazení potřebných částek nejprve projděte moduly DailyLoss, FinReserve, 1./2./3. invalidita a Smrt (potřebná zajištění se počítají tam).",
					RiskColumn: "Riziko",
					RequiredColumn: "Potřebné",
					CurrentColumn: "Sjednané",
					GapColumn: "Chybí",
					CoveredCell: "Pokryto",
				},
				Client: {
					ClientHeading: "Klient",
					PartnerHeading: "Partner",
					InsightContext: "Pokrytí napříč riziky",
					InsightPointe: "Z {{required}} potřebných je sjednáno {{current}}.",
					InsightFollowup:
						"Chybějící části doporučíme dokrýt vhodným pojištěním nebo rezervou.",
					InsightCovered: "Vše je pokryto v plné výši.",
					EmptyUpstream:
						"Pro zobrazení potřebných částek nejprve projděte předchozí moduly.",
				},
			},
			IncomeProtectionDeathShared: {
				Title: "Úmrtí",
				Subtitle:
					"Co se stane, když umřu? Vdovský důchod pro partnera + sirotčí důchody pro děti vs požadovaný příjem rodiny.",
				ShortDescription:
					"Modelace finančního dopadu úmrtí — vdovský a sirotčí důchod ČSSZ vs požadovaná částka.",
				Category: "Zabezpečení příjmů",
				PartnerToggle: { Label: "Přidat partnera", Toggle: "Přidat partnera" },
				Tabs: {
					Client: "Klient",
					Partner: "Partner",
					AriaLabel: "Klient nebo Partner",
				},
				Sections: { Inputs: "Vstupy modelace" },
				Inputs: {
					YAxisLabel: "Cílová úroveň zajištění",
					XAxisLabel: "Délka zajištění",
					CustomAmountLabel: "Vlastní částka",
					CustomPeriodLabel: "Doba zajištění",
					YearsSuffix: "let",
				},
				YAxis: {
					CustomAmount: "Vlastní částka",
					NetIncome: "Čistý příjem",
					TotalExpenses: "Celkové výdaje",
					MandatoryExpenses: "Nezbytné výdaje",
				},
				Metrics: {
					RevenueDropCover: "Zajištění propadu příjmů",
					RevenueDropCoverHint:
						"Jednorázová částka pokrývající propad po odečtení vdovského + sirotčích důchodů.",
					NecessarySecurityTotal: "Potřebné zajištění celkem",
					NecessarySecurityTotalHint:
						"Součet položek potřebného zajištění + krytí propadu.",
				},
				Chart: {
					Title: "Vývoj příjmu po úmrtí",
					Placeholder: "Pro zobrazení grafu zadejte vstupy.",
					AriaLabel:
						"Graf vývoje příjmu rodiny po úmrtí — vdovský důchod, sirotčí důchody (s diskontinuitami při dospívání dětí) vs požadovaný měsíční příjem.",
					SeriesFamilyIncome: "Zbylý příjem rodiny",
					SeriesWidowPension: "Vdovský důchod",
					SeriesOrphansPension: "Sirotčí důchody",
					SeriesRequestedAmount: "Potřebné zajištění",
					SeriesRequiredAmount: "Potřebná částka",
					RightAnnotationWithInflation: "s inflací:",
				},
				NecessarySecurityList: {
					Title: "Potřebné zajištění — položky",
					Empty: "Zatím žádné položky potřebného zajištění.",
					MoreItems: "+ {{count}} dalších položek",
				},
				ModalButtons: {
					Person: "Upravit údaje o osobách",
					Income: "Upravit příjmy",
					Expense: "Upravit výdaje",
					Option: "Nastavení",
					NecessarySecurity: "Upravit potřebné zajištění",
				},
				OptionModal: {
					Title: "Nastavení modelace",
					UseInflation: "Chci počítat s inflací",
					UseInflationTooltip:
						"Při výpočtu můžete zohlednit inflaci. V takovém případě budou všechny částky v čase valorizovány o hodnotu inflace.",
					InflationValue: "Roční inflace",
					UseEvaluation: "Chci počítat se zhodnocením",
					UseEvaluationTooltip:
						"Při výpočtu můžete počítat s tím, že získané prostředky budou v průběhu čerpání investovány. Očekávaný výnos pokryje část potřebných prostředků.",
					EvaluationValue: "Roční zhodnocení",
					CustomOrphanPeriod: "Doba pobírání sirotčího důchodu",
					CustomOrphanPeriodHint:
						"Do kolika let věku dítěte se pobírá sirotčí důchod (zákonný strop 26 při studiu, 18 jinak).",
					YearsSuffix: "let",
					UseCustomParameters: "Upravit parametry výpočtu",
					UseCustomParametersTooltip:
						"Vypočítané částky vdovského a sirotčího důchodu můžete nahradit vlastními hodnotami.",
					UseWidowPension: "Vlastní hodnota vdovského důchodu",
					UseWidowPensionTooltip:
						"Vypočítaný vdovský důchod můžete nahradit zadanou částkou. Výpočet vdovského důchodu neproběhne a bude se pracovat pouze se zde zadanou částkou.",
					WidowPensionValue: "Výše vdovského důchodu",
					UseOrphanPension: "Vlastní hodnota sirotčího důchodu",
					UseOrphanPensionTooltip:
						"Vypočítaný sirotčí důchod (per dítě) můžete nahradit zadanou částkou. Výpočet sirotčího důchodu neproběhne a bude se pracovat pouze se zde zadanou částkou.",
					OrphanPensionValue: "Výše sirotčího důchodu",
					InfoIconAriaLabel: "Vysvětlení",
					Apply: "Uložit nastavení",
				},
				Client: {
					ContextLabel: "Potřebné zajištění",
					Pointe:
						"Tolik si potřebujete zajistit, aby rodina udržela životní úroveň.",
					InputsTitle: "Vstupy modelace",
					InputsCustomAmount: "Vlastní částka",
					InputsCustomPeriod: "Doba zajištění",
					InputsNetIncome: "Čistý měsíční příjem",
					InputsGrossIncome: "Hrubý měsíční příjem",
					InputsYAxisLabel: "Cílová úroveň zajištění",
					InputsXAxisLabel: "Délka zajištění",
					NecessarySecurityTitle: "Potřebné zajištění — položky",
					NecessarySecurityEmpty: "Zatím žádné položky potřebného zajištění.",
					CustomOrphanPeriodLabel: "Doba pobírání sirotčího důchodu",
				},
			},
		},
		SystemForms: {
			ClientIdentity: {
				Title: "Identifikace klienta",
			},
			ClientGoals: {
				Title: "Cíle klienta",
			},
			MeetingNote: {
				Title: "Zápis ze schůzky",
			},
		},
		PathTemplates: {
			PageTitle: "Šablony cest",
			Heading: "Cesty pro klientskou schůzku",
			Subheading: "Šablony",
			Description:
				"Šablona je předpis kroků — jakmile ji spustíte, vznikne kopie, která se vyplní s konkrétním klientem.",
			EmptyState:
				"Zatím nejsou seedované žádné šablony. Spusťte dotnet run --project tools/BLogic.ModelingStudio.DataGenerator.",
			StartPath: "Spustit cestu",
			StepCount: "{{count}} kroků",
			CreateNew: "Vytvořit novou cestu",
			EditTemplate: "Upravit předpis cesty",
			CopyAsMine: "Udělat vlastní kopii cesty",
			CopySuffix: " (kopie)",
			Scope: {
				System: "Systémová",
				Tenant: "Firemní",
				Personal: "Osobní",
			},
			Filters: {
				ScopeAll: "Vše",
				ScopeSystem: "Systémové",
				ScopeTenant: "Firemní",
				ScopePersonal: "Moje",
			},
			Preview: {
				Heading: "Náhled cesty",
				StepsHeading: "Kroky cesty",
				EmptyPrompt: "Vyberte šablonu vlevo a uvidíte zde její kroky.",
				NoSteps: "Šablona nemá žádné kroky.",
			},
			Builder: {
				PageTitleNew: "Nová cesta",
				PageTitleEdit: "Úprava cesty",
				PageTitleCopy: "Kopie cesty",
				SubtitleNew: "Sestav vlastní cestu z modulů",
				SubtitleEdit: "Uprav svoji vlastní cestu",
				SubtitleCopy: "Uprav kopii a ulož ji jako svoji vlastní cestu",
				SavingButton: "Ukládám…",
				CancelButton: "Zrušit",
				DeleteButton: "Smazat cestu",
				DeleteConfirm:
					"Opravdu smazat tuto cestu? Cesta bude archivována a zmizí z knihovny.",
				DeleteSuccess: "Cesta byla archivována.",
				DiscardConfirm: "Máš neuložené změny — opravdu odejít?",
				NameLabel: "Název cesty",
				NamePlaceholder: "Pojmenuj cestu",
				DescriptionLabel: "Popis (volitelné)",
				DescriptionPlaceholder: "Krátký popis pro tebe / klienta",
				NameRequired: "Vyplň prosím název cesty.",
				ScopeLabel: "Sdílení",
				ScopeDescription:
					"Soukromou šablonu vidíš jen ty. Sdílenou s organizací mají k dispozici všichni poradci ve tvém tenantu.",
				ScopePersonal: "Soukromá",
				ScopeTenant: "Sdílená s organizací",
				ScopeSystem: "Systémová",
				ScopeSystemDescription:
					"Systémovou šablonu vidí všichni napříč organizacemi. Mohou ji vytvářet a upravovat pouze správci systému.",
				LeftPanel: {
					Heading: "Knihovna komponent",
					SearchPlaceholder: "Hledat modul…",
					CategoryAll: "Všechny kategorie",
					CategoryModules: "Moduly",
					AlreadyAdded: "Již v cestě",
					EmptyFilter: "Žádné moduly neodpovídají filtru.",
				},
				Center: {
					EmptyHint:
						"Přetáhni komponentu z levého sloupce, nebo klikni v levém panelu pro přidání na konec.",
					AddAtEnd: "Přidat další modul z knihovny",
					StepIndex: "Krok {{index}}",
					RemoveStep: "Odstranit krok",
					DragHandle: "Přetáhni pro změnu pořadí",
				},
				Right: {
					EmptyHint: "Vyber krok v ose příběhu.",
					NameLabel: "Název v tomto příběhu",
					NameHint: "Můžeš krok přejmenovat pro klienta.",
					OpenCustomModule: "Otevřít modul v knihovně",
				},
				Errors: {
					TemplateNotFound: "Cesta nebyla nalezena nebo k ní nemáš přístup.",
					NotOwner: "Tuhle cestu nemůžeš upravovat — není tvoje.",
					StepKindNotSupportedYet:
						"Tento typ kroku zatím nelze do cesty přidat.",
					NotAuthenticated: "Nejsi přihlášen.",
				},
			},
		},
		PathRuns: {
			PageTitle: "Modelace",
			Heading: "Rozpracované cesty",
			Subheading: "Modelace",
			Description:
				"Všechny vaše rozpracované modelace — kalkulačky i průchody šablonami.",
			EmptyState: "Zatím žádné modelace. Spusťte cestu z knihovny šablon.",
			SectionPathsHeading: "Cesty",
			ClientLabel: "Klient: {{name}}",
			TemplateLabel: "Šablona: {{name}}",
			StepCount: "{{count}} kroků",
			Status: {
				Draft: "Rozpracováno",
				Ready: "Připraveno",
				Presented: "Prezentováno",
				Closed: "Uzavřeno",
			},
			Detail: {
				PageTitle: "Modelace",
				BackToList: "Zpět na seznam",
				NotFound: "Modelace nebyla nalezena.",
				StepsHeading: "Kroky cesty",
				NoSteps: "Tato modelace nemá žádné kroky.",
				CloseButton: "Uzavřít modelaci",
				CloseSubmitting: "Uzavírám…",
				ShowOutputs: "Zobrazit výpočet",
				HideOutputs: "Skrýt výpočet",
				NotComputed: "Výpočet zatím neběžel.",
				ComputedAt: "Spočítáno {{date}}",
				StepKind: {
					ModelingModule: "Modul",
					SystemForm: "Systémový formulář",
					CustomModule: "Vlastní modul",
				},
				PendingFeatures:
					"Tip: hodnoty sdílených systémových vstupů se mezi kroky propisují automaticky. Když je na některém kroku přepíšeš jinak, systém se zeptá, zda změnit všude nebo jen lokálně.",
				SaveInputs: "Uložit vstupy",
				SavingInputs: "Ukládám…",
				Recompute: "Spočítat",
				Recomputing: "Počítám…",
				InputsHeading: "Vstupy",
				OutputsHeading: "Výstupy",
				ResetInputs: "Načíst znovu",
				NotSupportedYet: "Editace tohoto typu kroku není v MVP podporována.",
				OpenStep: "Otevřít krok",
				StepStatusPending: "Čeká na výpočet",
				StepStatusComputed: "Spočítáno",
			},
			Step: {
				PageTitle: "Krok cesty",
				BackToOverview: "Zpět na přehled cesty",
				StepIndicator: "Krok {{current}} z {{total}}",
				PreviousStep: "Předchozí krok",
				NextStep: "Další krok",
				StepNotFound: "Krok nebyl v této cestě nalezen.",
				PdfLoading: "Načítám PDF…",
				PdfLoadFailed: "Nepodařilo se načíst PDF.",
				PdfDownload: "Stáhnout PDF",
				PdfPageIndicator: "Strana {{current}} z {{total}}",
				PdfPreviousPage: "Předchozí strana",
				PdfNextPage: "Další strana",
				PdfFullscreen: "Zobrazit na celou obrazovku",
				PdfFullscreenTitle: "Náhled PDF",
				Form: {
					SaveButton: "Uložit odpovědi",
					Saving: "Ukládám…",
					SaveSuccess: "Odpovědi byly uloženy.",
					EmptyFields: "Tento formulář nemá žádná pole.",
				},
			},
			SharedFieldDiverge: {
				Title: "Hodnota se odlišuje od ostatních kroků",
				Description:
					"Tato pole se rozcházejí s hodnotou sdílenou napříč modelací. Vyber, zda změnu propsat do všech navázaných kroků, nebo ji ponechat lokální jen pro tento krok.",
				Change: "{{oldValue}} → {{newValue}}",
				Propagate: "Propagovat do všech kroků",
				MakeLocal: "Ponechat lokální pro tento krok",
			},
		},
	},
};
